var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeDevopsLandscape = function SvgHomeDevopsLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2164 1242"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__e",
    x1: "104%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67d0ff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#539eff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__g",
    x1: "98.8%",
    x2: "-32%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be99ff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45c7ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__h",
    x1: "110.3%",
    x2: "35.7%",
    y1: "45.2%",
    y2: "70.9%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c93ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c93ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__i",
    x1: "100%",
    x2: "35.7%",
    y1: "50%",
    y2: "70.9%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73dce8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9a6e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__j",
    x1: "100%",
    x2: "35.7%",
    y1: "50%",
    y2: "70.9%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8778e3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a497f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a497f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__k",
    x1: "98.3%",
    x2: "35.7%",
    y1: "46.9%",
    y2: "70.9%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f9ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99c0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7fb3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8590FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__l",
    x1: "-56.4%",
    x2: "133.6%",
    xlinkHref: "#home-devops-landscape_svg__a",
    y1: "22.9%",
    y2: "74.7%"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__n",
    x1: "0%",
    x2: "84.5%",
    y1: "40.2%",
    y2: "22.7%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6c3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98c1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__I",
    x1: "95%",
    x2: "35.4%",
    y1: "47.2%",
    y2: "63.1%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#23a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e578e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b89ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__Z",
    x1: "9%",
    x2: "125.9%",
    y1: "21.1%",
    y2: "103.3%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#95c1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e76e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__N",
    x1: "59.9%",
    x2: "50%",
    y1: "9.9%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9da9e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#daa1e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__O",
    x1: "23.4%",
    y1: "34.1%",
    y2: "75.7%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#addfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61a0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__ab",
    x1: "24.2%",
    x2: "79.2%",
    y1: "16.6%",
    y2: "83.4%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3d0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed99eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__T",
    x1: "-9.3%",
    x2: "94.8%",
    y1: "28.4%",
    y2: "79.5%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9dc6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c27ebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__ah",
    x1: "3.3%",
    y1: "16.4%",
    y2: "83.7%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dab8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3d3dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__ai",
    x1: "3.3%",
    x2: "84.1%",
    y1: "47.4%",
    y2: "52.6%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3b5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe2f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__al",
    x1: "3.3%",
    y1: "6.5%",
    y2: "93.5%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9c1de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3d3dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__ao",
    x1: "-6.2%",
    x2: "77.5%",
    y1: "0%",
    y2: "75.4%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edcae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c484ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__av",
    x1: "13.5%",
    x2: "88.3%",
    y1: "0%",
    y2: "83.3%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe1ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c697ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab90ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__ay",
    x1: "9%",
    x2: "102.3%",
    y1: "42.3%",
    y2: "56%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8aadf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#887adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a176c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__az",
    x1: "23.2%",
    x2: "69.8%",
    y1: "34.4%",
    y2: "67.5%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a58eff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__aD",
    x1: "35.2%",
    x2: "62.7%",
    y1: "26.6%",
    y2: "45%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ceb4ff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3f8ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__aU",
    x1: "66%",
    x2: "34%",
    y1: "36%",
    y2: "60.5%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3b5ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3d0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e59ae3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__aV",
    x1: "0%",
    xlinkHref: "#home-devops-landscape_svg__b",
    y1: "50%",
    y2: "50%"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__aX",
    x1: "3.3%",
    x2: "84.1%",
    y1: "35%",
    y2: "64.8%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3b5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe1e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__aZ",
    x1: "24.2%",
    x2: "79.2%",
    xlinkHref: "#home-devops-landscape_svg__b",
    y1: "33.3%",
    y2: "66.7%"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bc",
    x1: "24.2%",
    x2: "79.2%",
    xlinkHref: "#home-devops-landscape_svg__b",
    y1: "32.4%",
    y2: "67.6%"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bd",
    x1: "24.2%",
    x2: "79.2%",
    xlinkHref: "#home-devops-landscape_svg__b",
    y1: "32.4%",
    y2: "67.6%"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bh",
    x1: "100%",
    x2: "12.9%",
    y1: "33%",
    y2: "67%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8662f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bi",
    x1: "100%",
    x2: "0%",
    y1: "33%",
    y2: "67%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2dbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b57a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bj",
    x1: "31.6%",
    x2: "73.6%",
    y1: "63.8%",
    y2: "38.3%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#89c9f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8590FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bk",
    x1: "56.8%",
    x2: "43.4%",
    y1: "0%",
    y2: "98.6%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a295f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d8cc8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bl",
    x1: "32%",
    x2: "64.2%",
    xlinkHref: "#home-devops-landscape_svg__a",
    y1: "9.3%",
    y2: "86.9%"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bm",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#759CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6069E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bo",
    x1: "23.4%",
    y1: "24.1%",
    y2: "90.8%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397ce1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bp",
    x1: "23.4%",
    x2: "99.2%",
    y1: "46.3%",
    y2: "55.9%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-devops-landscape_svg__bq",
    x1: "23.4%",
    y1: "46.7%",
    y2: "55.3%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3d1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__c",
    d: "M1485 69.3h.2-3l-139.3 1H.5v-69l1484.4-1v69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__r",
    d: "M24.2 16.6c-2-.6-4.1-.5-8.2-4.7-1-.2-2-.2-3.4-.3l1.5-1.2 3.7-2.9c2 0 3.7 1.2 5.4 2l1.5.9c1.9 1 3.7 2.1 5.5 3.3-1.2 1-2.4 3-1.3 4.4a36.3 36.3 0 0 1-4.7-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__s",
    d: "M18 3.1c-1 .2-1.8 1-2.7 1.3a13.2 13.2 0 0 0-2-.6 10 10 0 0 1-2.4-1.4c.3-.2.6-.4.7-.7l-.1-.1.7-.6c.1 0 .3 0 .4-.2l.4-.6V0l2.5.8.6.7c.2 0 .3.2.5.4l.5.6c.2.3.5.5.8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__t",
    d: "m8.7 9.4 7 3.1H15l-1.6-.1a34.1 34.1 0 0 1-3.7-.5l-.6-.1a1.4 1.4 0 0 1-.1 0 7.8 7.8 0 0 0-.6-1.2C8 9.8 7.4 9 6.8 8.3l.6.4.5.2.2.2.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__v",
    d: "m13 .1-.4.7c-.1.2-.2.2-.4.2l.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__u",
    d: "m12.7 5.6.3.3-4.5 2.6v.8a6.1 6.1 0 0 1-.4-.2L8 8.9a10.4 10.4 0 0 1-1-.6 11.4 11.4 0 0 0-2-1.6c-.4-.3-.5-.7-.7-1a5.6 5.6 0 0 1-.1-1.1h1.2a6.2 6.2 0 0 0 3-.3 21.3 21.3 0 0 0 4.4 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__y",
    d: "M11.5 1.6h.1c-.1.4-.4.6-.7.9l-.5-.4 1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__w",
    d: "M8.7 11c0 .3.2.5.3.7a21.8 21.8 0 0 1-6.3-3.1A6.3 6.3 0 0 1 .3 6C-.1 5.2 0 4.8 0 4.2v.2l1.4.6 1 .4.7.4h.2a10.8 10.8 0 0 1 3.4 2.5 10.9 10.9 0 0 1 2 2.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__B",
    d: "m7.9 4 .5.3a6.2 6.2 0 0 1-3 .4c.8 0 1.6-.4 2.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__x",
    d: "M4.8 6.6v.1L3.5 6l-.2-.1-.8-.4-.9-.4-1.4-.6v-.2l.1-.5.3-.6 1.7 1 1.9.5.1 1v.1c.2.3.3.7.6 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__z",
    d: "M7.6 12.8v.9a6.2 6.2 0 0 0 .3 1.6l.5 1.1a7.2 7.2 0 0 0 1.7 1.5l.3.4.1-.1a19.4 19.4 0 0 1 2.2 1.8 20 20 0 0 1 1.9 2.4c.4.9.8 1.8.9 2.9l-.2 2.3-.5 2.3a3.6 3.6 0 0 0 .2 1.8 4.7 4.7 0 0 0 1.7 2 5 5 0 0 1-1 .5l-2.1-1.6-.2-.1-.7-.6-.2-.1-.1-.2-1.2-1a8 8 0 0 0-2.5-1.7l-.3-.7v-.5L8 26v-.8c-.3-2.1-.5-4.6-1-6.5 0-.4-.2-.9-.4-1.2v-.2l-.6-1c-.5-.4-.8-.6-1.7-.8h-.7c.8-.9 3.4-2.3 3.9-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__G",
    d: "M16.4 6.5c0 .9 0 1.7-.4 2.6 0-.9.3-2 .4-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__A",
    d: "M16.1 20.2c.2.8.1 1.8 0 3v.3c-.2.4-.5 1.1-.6 1.8a6.8 6.8 0 0 0-1-2.9V21a17.1 17.1 0 0 0-1.1-4.5l.8-.2v.1a8.7 8.7 0 0 1 2 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__J",
    d: "M15.2 10.2h.3a3.8 3.8 0 0 1-.6.7 3.3 3.3 0 0 0-.4-.4l.2-.3h.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__C",
    d: "m14.9 10.9.7.7c-.6.2-1.2.2-1.7 0l1-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__M",
    d: "m14.5 10.6.4.3-1 .6.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__D",
    d: "M14.6 21v1.4a15.8 15.8 0 0 0-2-2.4c-.2-.4-.5-.6-.8-.9l-1.3-.9c.6-.7 1.6-1.2 2.6-1.6h.3c.5 1.4 1 3 1.2 4.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__P",
    d: "m10.4 11.8-.4.1-.2-.2v-.4c0 .2.3.4.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__R",
    d: "M9.8 6.6v1.7c0 .6-.3 1.2-.5 1.7 0-1.2.3-2.6.5-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__F",
    d: "M9.7 11.3v.3a6.3 6.3 0 0 1-.2-.1l-.8-.6.2-.2.4.2h.2l.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__U",
    d: "m9.5 11-.1-.1-.5-.2.3-.4V10l.1-.1.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__d",
    d: "M388.8 38.9c-89.4-51.6-233.7-51.6-322.4 0-88.8 51.5-88.3 135.2 1 186.8 89.3 51.5 233.7 51.5 322.4 0 88.8-51.6 88.3-135.3-1-186.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__K",
    d: "m57.3 56 32.5 12.5V37.3L57.3 24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__L",
    d: "m17 .3-1.8.1-1.9.2H12l-3 .6c-.8 0-1.6.1-2.3.3H6L.7 2.7V34c2-.5 4-1 6-1.3l2.3-.3a65.2 65.2 0 0 1 6.1-.6 77.6 77.6 0 0 1 5.3-.1h.8l6 .3 1.5.2 5 .8 1 .1 5.8 1.4 2.3.8 3.7 1.3 1 .5c1.7.7 3.3 1.5 4.9 2.4 7.2 4.1 11.8 9.6 13.1 15.4l.1-31.3c-1.3-5.8-6-11.2-13.1-15.4a50.3 50.3 0 0 0-5-2.4l-1-.4-.8-.4-2.9-1-2.2-.7L40 3a66.9 66.9 0 0 0-4.9-1.2h-.4l-1-.2-3.2-.6c-.6 0-1.2 0-1.8-.2L27.3.7 26.1.5 21.6.3H17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__ac",
    d: "M105.8 124.1v31.3l23.5-17.4.1-31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__ad",
    d: "M.8 31.9c0 15.9 10.5 31.8 31.7 44a106.8 106.8 0 0 0 7 3.7l2.5 1 5 2.3.9.3 4.1 1.5 1.8.7c2.3.7 4.6 1.5 7 2.1l.3.1 1 .3 6.3 1.6 1.9.4 1.6.4 2.1.3 6.6 1.2 1.8.3a169.4 169.4 0 0 0 7.9.9l2.4.2 2.5.2 6.2.3h4.7V62.6h-4.6l-6.2-.4c-1.7 0-3.3-.3-5-.4a167.4 167.4 0 0 1-9.6-1.2L74 59.4l-3.7-.8a156.3 156.3 0 0 1-8.2-2l-1-.2-7.3-2.3-1.8-.6a131 131 0 0 1-5-1.9l-5-2.2-2.5-1a107.2 107.2 0 0 1-7-3.8C11.4 32.5.8 16.6.9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__V",
    d: "M249.9 125.2v31.3l23.3-17.5.1-31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__ag",
    d: "m117.5 155.9 38.3.1v-31.2l-38.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__ak",
    d: "m216.5 156.3 33.7.1v-31.2l-33.6-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__an",
    d: "M.2 31.7H4l3.4.2 1.5.1 2.9.4 1.4.2 2.8.5 1.4.2 4.1 1h.1c1.8.6 3.4 1.1 5 1.8l1 .3a55 55 0 0 1 2.2 1l1 .4 3.1 1.6c9.1 5.3 13.7 12.1 13.6 19l.1-31.3c0-6.8-4.5-13.7-13.6-19l-3-1.5-1.1-.5-2.2-1-.4-.1-.6-.2a60 60 0 0 0-5-1.7 68.9 68.9 0 0 0-4.3-1l-.5-.2-.8-.1a88 88 0 0 0-2.8-.5l-.9-.1L12 1 9 .7H7.5L4 .4H.3L.2 31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__ax",
    d: "M197.3 33.3a63.6 63.6 0 0 1-3 2.6l-1.7 1.3-1.6 1.2-1.8 1.2a81.6 81.6 0 0 1-3.6 2.4l-2.5 1.5a114.5 114.5 0 0 1-10.2 5.2 159.3 159.3 0 0 1-7.4 3l-2.2.8-5.6 1.9-33 6.4-4 .4-6.8.4h-11.6c-3 0-6.1-.2-9.2-.5l-1.7-.1a175 175 0 0 1-9-1l-1.3-.2c-3.3-.5-6.5-1-9.6-1.7l-2.5-.5-3.1-.7-2.5-.7-3-.8L59 55l-4.8-1.5-2-.6-4-1.5-1.7-.7-7-3-1.3-.6a110 110 0 0 1-6.7-3.5C15.2 34.2 3.9 21.8.8 7.6L.2 4.1 0 35.3.7 39C4 53 15.1 65.5 31.4 74.9c2.1 1.2 4.4 2.3 6.8 3.5l1.2.6 7 3 .6.3 1.1.4a152.9 152.9 0 0 0 6 2.1l4.8 1.5 1 .3.4.1 3 .8 2.5.6 3.2.7 2.3.6h.1c3.1.6 6.3 1.2 9.6 1.6l.8.2h.5c3 .5 6 .8 9 1l.8.1 1 .1 9.1.5h11.6a171.9 171.9 0 0 0 11.6-.8l3-.4 2.4-.3c2.7-.3 5.4-.7 8-1.2h.1l6.3-1.3 2.6-.6c2.9-.6 5.7-1.4 8.5-2.2l1.3-.4 5.6-2 2.2-.7 7.4-3c3.6-1.6 7-3.4 10.3-5.3l1.2-.7 1.2-.8 2-1.2 1.5-1a65 65 0 0 0 3.4-2.5l1.7-1.3 1.4-1.2 1.6-1.3.6-.5A44.8 44.8 0 0 0 214 31.4l.1-31.3c0 11.5-5.7 23-16.8 33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__aE",
    d: "M389.9 125.7C300.6 74 156.2 74 67.5 125.7c-44.3 25.7-66.3 59.4-66.3 93L0 280c0 34 22.4 68 67.4 94 5.3 3.2 11 6 16.7 8.8l5.9 2.5c3.4 1.6 6.7 3.1 10.2 4.5l1.9.7 4 1.4a286 286 0 0 0 13.8 4.8l4.8 1.5 3.2 1a313.3 313.3 0 0 0 17 4.2l6.8 1.6 5.7 1c4 .7 8 1.5 12 2l4.9 1 5.3.5c3.8.5 7.6 1 11.4 1.3 1.8.2 3.6.5 5.5.6l5 .3 11.6.6c2 0 3.9.3 5.8.3h17.2l6.2-.1 6.3-.3 3.4-.2 15.6-1.2 3-.3 4.5-.6c5.3-.6 10.6-1.4 15.8-2.2l3.9-.6 1.8-.3 7.4-1.6 12.6-2.7 9-2.4 11.7-3.4 2.5-.7a297 297 0 0 0 13.8-4.9l2-.8a263.8 263.8 0 0 0 18.7-8.2 238.3 238.3 0 0 0 15.4-8l2.8-1.7 2.5-1.6a171 171 0 0 0 7.8-5 184.1 184.1 0 0 0 7.2-5.3 149.7 149.7 0 0 0 3.6-2.8l3.1-2.6 3.3-3 1.4-1.1 1.1-1.1a140 140 0 0 0 5.2-5.2l1.7-1.7 5.9-7 .2-.2c.5-.5.8-1.1 1.2-1.6l3.2-4.4 1.6-2.5 2.5-4 .7-1.1.9-1.7a96.6 96.6 0 0 0 4.5-9.8l.7-1.5.5-1.4a82.1 82.1 0 0 0 2.7-9.6l.5-1.8c0-.5 0-.9.2-1.3l.5-3.4.4-3 .2-3.4.2-2v-2l1-58.6c1.5-35-20.9-70.2-67.1-97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__aJ",
    d: "m27.5 42.5 14-.2-7 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-devops-landscape_svg__bg",
    d: "M3.1 149.3h31.2l51.9-48.4z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#home-devops-landscape_svg__c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9.6A8 8 0 0 0 29.3 2L24 5c-.9-.8-1.8-1.5-2.8-2-3-1.8-5.7-2-7.6-.8L.5 9.8l10.4 3.4a24.2 24.2 0 0 0 10.3 14.6l37.6 21.8L61.6 63l12.8-7.5c1.7-1 2.6-3 2.6-5.7 0-5.7-4-12.6-8.8-15.5a8.4 8.4 0 0 0-3.6-1.2V33c0-4.4-3.1-9.8-7-12a6.4 6.4 0 0 0-3-1A34.6 34.6 0 0 0 41 2.7a14.3 14.3 0 0 0-7-2.1h-.1z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4 6.5c-1.4-1.7-3-3-4.7-4C4.8-.9 0 1.8 0 8.7s4.8 15.2 10.7 18.6l47 27.2a8 8 0 0 0 4 1.3c3 0 4.9-2.4 4.9-6.4 0-5.7-4-12.6-8.9-15.4a8.4 8.4 0 0 0-3.6-1.2v-.3c0-4.5-3-9.9-7-12a6.4 6.4 0 0 0-2.9-1A34.6 34.6 0 0 0 30.5 2.3a14 14 0 0 0-7-2.3c-3.9 0-6.8 2.3-8 6.4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .1h10.7V5H0z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__E",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .1h5.8v12.4H0z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__W",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#home-devops-landscape_svg__d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aa",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 1.6-.1 31.2V1v.4z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__ap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2 1.3v-1z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aq",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.4c.4-2 .6-4 .7-6.1z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__ar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 7a38.8 38.8 0 0 0 1.8-6z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__as",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.8c1.2-2 2.1-4 2.9-6.1z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__at",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 6.8A49.7 49.7 0 0 0 4.8.4z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__au",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.2 7.5a61 61 0 0 0 6.7-7z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aA",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .2h6.4v8.3H.1z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12.3v9.5H0z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aC",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.2.4h6.3V13H.3z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aG",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.4.6h6.5v7H.4z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6.6v7H0z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aI",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5.2h12.8v19.6H.5z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4.4V7l-.3.4c-.4.2-1 .2-1.3 0C.6 7.3.5 7 .5 7V.4h1.9z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aM",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4.1v6.6l-.3.4c-.4.2-1 .2-1.4 0l-.2-.4V.1z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4.5V7c0 .2-.1.3-.3.4-.4.2-1 .2-1.4 0L.5 7V.5h1.9z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aO",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3.2v6.6l-.2.4c-.4.2-1 .2-1.4 0l-.3-.4V.2z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3.5v6.6c0 .2 0 .3-.2.4-.4.2-1 .2-1.4 0-.2-.1-.3-.2-.3-.4V.5h2z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aQ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3.3v6.5c0 .2 0 .3-.3.4-.3.2-1 .2-1.3 0-.2-.1-.3-.2-.3-.4V.3h2z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3.6v6.5c0 .2-.1.3-.3.4-.4.3-1 .3-1.3 0-.2 0-.3-.2-.3-.3V.6z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aS",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3.3V7l-.3.4c-.4.2-1 .2-1.3 0C.5 7.3.4 7.1.4 7V.3h1.9z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3 0v6.6L2 7c-.4.2-1 .2-1.4 0l-.2-.4V.1h1.9z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aW",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 27.9c0 .8.5 1.7 1.7 2.4l11 6.1-.1 15.3 41 23.7c.8.5 1.8.8 2.9.9v-43a7.8 7.8 0 0 1-3-1L1.7 2.3C.6 1.8 0 1 0 0z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aY",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.4 3 7 6.8V4.6L.4.8z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__ba",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.4 2.4 7 6.2V4L.4.2z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__bb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.4 2.1 2.2 1.4v-2L.4.2z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__aK",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.8 2.4 3 3.8v-2L.8.6z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-devops-landscape_svg__be",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.3 2.7 2.2 1.4V2L.3.9z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__q",
    height: "137.9%",
    width: "122.6%",
    x: "-17%",
    y: "-18.9%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.354731206 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__H",
    height: "124.2%",
    width: "114%",
    x: "-7%",
    y: "-10.6%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.635892029 0 0 0 0 0.736917433 0 0 0 0 0.925498188 0 0 0 0.333424388 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__X",
    height: "180%",
    width: "207.6%",
    x: "-53.8%",
    y: "-35.4%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.590193695 0 0 0 0 0.69776332 0 0 0 0 0.902145607 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__Y",
    height: "177%",
    width: "164.6%",
    x: "-32.3%",
    y: "-27.5%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.130355409 0 0 0 0 0.279146497 0 0 0 0 0.827813632 0 0 0 0.34604458 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__Q",
    height: "151.4%",
    width: "205.9%",
    x: "-53%",
    y: "-17.5%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.711737805 0 0 0 0 0.817433943 0 0 0 0 1 0 0 0 0.459052666 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__S",
    height: "145.1%",
    width: "139.9%",
    x: "-23.7%",
    y: "-16.1%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 6,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.733333333 0 0 0 0 0.725490196 0 0 0 0 0.898039216 0 0 0 0.575092876 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__ae",
    height: "151.3%",
    width: "206.4%",
    x: "-53.2%",
    y: "-17.4%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.711737805 0 0 0 0 0.817433943 0 0 0 0 1 0 0 0 0.459052666 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__af",
    height: "179.5%",
    width: "165.2%",
    x: "-32.6%",
    y: "-27%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.711737805 0 0 0 0 0.817433943 0 0 0 0 1 0 0 0 0.459052666 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__aj",
    height: "179.5%",
    width: "174.1%",
    x: "-37.1%",
    y: "-27%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.711737805 0 0 0 0 0.817433943 0 0 0 0 1 0 0 0 0.459052666 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__am",
    height: "143.1%",
    width: "152.7%",
    x: "-26.3%",
    y: "-14.7%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.711737805 0 0 0 0 0.817433943 0 0 0 0 1 0 0 0 0.459052666 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__aw",
    height: "136.7%",
    width: "115.9%",
    x: "-7.9%",
    y: "-10.8%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.134046184 0 0 0 0 0.222129666 0 0 0 0 0.813547328 0 0 0 0.138904065 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__aF",
    height: "109.8%",
    width: "107%",
    x: "-3.5%",
    y: "-4.9%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.380392157 0 0 0 0 0.592156863 0 0 0 0 0.925490196 0 0 0 0.219077797 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__bf",
    height: "128.9%",
    width: "108.4%",
    x: "-4.2%",
    y: "-7.2%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.43178441 0 0 0 0 0.458752486 0 0 0 0 0.762143342 0 0 0 0.614291958 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__bn",
    height: "125.3%",
    width: "122.2%",
    x: "-11.1%",
    y: "-12.6%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.546737833 0 0 0 0 0.568297183 0 0 0 0 0.83239923 0 0 0 0.631173514 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "home-devops-landscape_svg__br",
    height: "252.3%",
    width: "217.5%",
    x: "-58.8%",
    y: "-76.1%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.0821882791 0 0 0 0 0.253763346 0 0 0 0 0.554829031 0 0 0 0.418815559 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#3074fc",
    strokeOpacity: 0.2,
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1626.6 1.4 536.9 310-537 309.8-536.9-309.9zm-511.4 295.2 536.9 309.9m-511.3-324.7 536.9 310M1166.3 267l537 309.8m-511.4-324.6 536.9 309.9m-511.3-324.7 536.9 310M1243 222.7l537 309.9M1268.5 208l537 310m-511.4-324.7L1831 503.2m-511.4-324.7 537 310m-511.4-324.8 537 310M1370.8 149l536.9 309.9m-511.3-324.7 536.9 310M1422 119.4l537 309.9m-511.4-324.7 536.9 310M1473.2 89.8 2010 400M1498.7 75.2l537 309.9M1524.2 60.4l536.9 310M1549.9 45.6l536.9 309.9M1575.4 30.9l537 310M1601 16.1 2137.9 326m0-29.6-537 310m511.4-324.7-536.9 310M2086.8 267l-537 310m511.4-324.7-537 309.9m511.4-324.7-536.9 310m511.4-324.7-537 309.9M1984.5 208l-537 310M1959 193.1l-536.9 310m511.4-324.7-537 310m511.4-324.8-537 310M1882.3 149l-536.9 309.9m511.4-324.7-537 310m511.4-324.7-537 309.9m511.4-324.7-536.9 310M1780 89.8l-537 310m511.4-324.7-537 309.9m511.4-324.7-536.9 310m511.4-324.7-537 309.9m511.4-324.7-537 310m511.4-324.7L1115.2 326m510.5 294.8-537 310-536.8-310 536.9-310M577.4 606.2l537 310M603 591.4l536.9 309.9M628.6 576.6l536.9 310M654 561.8l537 309.9M679.6 547l536.9 310M705.3 532.3l536.9 309.9M730.8 517.6l537 310M756.3 502.7l536.9 310M782 488l536.9 310M807.5 473.3l537 310M833 458.5l537 309.9M858.6 443.8l536.9 310M884.2 429l537 309.9M909.7 414.3l537 309.9M935.3 399.5l536.9 310M960.9 384.7l537 309.9M986.5 370l537 310M1012 355.2l537 310m-511.3-324.7 536.9 310m-511.4-324.8 537 310m0-29.6-537 310m511.4-324.7-537 310M1549 576.5l-537 310m511.4-324.7-536.9 310M1497.9 547l-537 310m511.4-324.8-537 310m511.4-324.7-536.9 310m511.4-324.8-537 310M1395.6 488l-537 310M1370 473.3l-536.9 310m511.4-324.7-537 309.9M1319 443.8l-537 310M1293.4 429 756.3 739m511.5-324.7-537 310m511.4-324.8-537 310m511.4-324.7-537 309.9M1191.2 370 654 680m511.4-324.7-537 309.9M1140 340.5l-537 310m511.5-324.7-537 309.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1088.8 930.8-536.9 310L15 930.7 552 621M40.5 916.1l537 309.9M66 901.3l537 310M91.6 886.4l536.9 310M117.3 871.8l536.9 309.9M142.8 857l537 310M168.3 842.2l537 309.9M194 827.5l536.9 310M219.5 812.7l537 309.9M245 798l537 310M270.6 783.1l536.9 310M296.2 768.4l537 309.9M321.7 753.7l537 310M347.3 739l536.9 309.9M372.9 724.2l537 310M398.4 709.4l537 309.9M424 694.7l537 309.9M449.7 679.9l536.9 310M475.2 665.1l537 309.9M500.7 650.4l536.9 310M526.4 635.6l536.9 309.9m0-29.5-537 309.9m511.4-324.7-537 310m511.4-324.8-536.9 310m511.4-324.7-537 310M961 857l-537 310m511.4-324.7-536.9 309.9m511.4-324.7-537 310m511.4-324.8-537 310M858.8 798l-536.9 310m511.4-324.8-537 310m511.4-324.7-537 309.9M782 753.7l-536.9 310M756.5 739l-537 309.9M731 724.2l-537 310m511.4-324.8-536.9 310m511.4-324.7-537 310m511.4-324.8-537 310m511.4-324.7L91.7 975m511.4-324.7-537 310m511.4-324.7-537 309.9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(30 -891.8 -2227.4)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#home-devops-landscape_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-606.7 124.3c-433.3-11.2 148.8-79.2 195.2-79.2s31.7 34.5 220.4 34.5 185.4-11.3 224-11.3c38.5 0 60.1-12 139.3-12 79.1 0 124.1 8.4 197.9 8.4s234.2-26.1 327.5-26c93.3.1 192.7 14.6 238.2 20.3 45.5 5.8 470.4-27.6 505.4-13 23.3 9.8 22 24.8-4 45-1073.7 29.7-1755 40.8-2043.9 33.3z",
    fill: "url(#home-devops-landscape_svg__e)",
    mask: "url(#home-devops-landscape_svg__f)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-88.1 119.5c-3-27.7 306.4-88.8 535.1-88.8 228.8 0 310.4 23 431.2 23s145.5-14 249.4-16.2c103.8-2.2 131 10.9 307.6 12 24.1.2 29.6 26 9 29.7C1252 113.5-85.5 143.5-88.1 119.5z",
    fill: "url(#home-devops-landscape_svg__g)",
    mask: "url(#home-devops-landscape_svg__f)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1140 636-26 15-26-15 26-15z",
    fill: "#8c93ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1294 576-25-14.4-100 58.4 25 14.4z",
    stroke: "url(#home-devops-landscape_svg__h)",
    transform: "translate(-54 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526 871 26-15 26 15-26 15z",
    fill: "#8c93ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 885-25-14.4L480 929l25 14.4z",
    stroke: "url(#home-devops-landscape_svg__h)",
    transform: "rotate(180 515.5 907.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m989 871-25-14.4L864 915l25 14.4z",
    stroke: "url(#home-devops-landscape_svg__i)",
    transform: "rotate(180 899.5 893.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1345 354-25-14.4-100 58.4 25 14.4z",
    stroke: "url(#home-devops-landscape_svg__j)",
    transform: "matrix(1 0 0 -1 -54 753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1139.2 340.5 27.3 15.7 26.6-15.1-27-15.7z",
    fill: "#a497f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m961 857-26 15-26-15 26-15z",
    fill: "#c99ed6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350 827-24-15.4-77 44.4 25 14.4z",
    stroke: "url(#home-devops-landscape_svg__k)",
    transform: "matrix(-1 0 0 1 545 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 871.5 296.6 887 270 871.5l26.4-15.5z",
    fill: "#7aadff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(376 305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124 463.1 25.6-14.2 77 44.1 66.4-38.4V436",
    stroke: "#9283ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.9 29.6v9.6c-.4 1.3-1.8 2.6-4.1 3.7l-75.3 43a15.5 15.5 0 0 1-14 .7L180.1 62c-1.8-1-2.7-1.8-3-3.8-.2-1.3-.2-4.3 0-9L226 29.4l30.4.8c4.1-2.4 10.4-2.6 14-.5l-.3-.3h45.8z",
    fill: "#aab0e4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 54.4c-3.6-2.1-3.1-5.8 1-8.2l76-43.2c4.1-2.4 10.4-2.7 14-.6l44 25c3.6 2 3.2 5.7-1 8.1l-75.9 43.2c-4.1 2.4-10.5 2.7-14 .6z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9.6A8 8 0 0 0 29.3 2L24 5c-.9-.8-1.8-1.5-2.8-2-3-1.8-5.7-2-7.6-.8L.5 9.8l10.4 3.4a24.2 24.2 0 0 0 10.3 14.6l37.6 21.8L61.6 63l12.8-7.5c1.7-1 2.6-3 2.6-5.7 0-5.7-4-12.6-8.8-15.5a8.4 8.4 0 0 0-3.6-1.2V33c0-4.4-3.1-9.8-7-12a6.4 6.4 0 0 0-3-1A34.6 34.6 0 0 0 41 2.7a14.3 14.3 0 0 0-7-2.1h-.1z",
    fill: "url(#home-devops-landscape_svg__l)",
    mask: "url(#home-devops-landscape_svg__m)",
    transform: "matrix(-1 0 0 1 284.5 4.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7 2.5C4.8-.9 0 1.8 0 8.7s4.8 15.2 10.7 18.6l48 27.2a8 8 0 0 0 4 1.3c3 0 4.9-2.4 4.9-6.4 0-5.7-5-12.6-9.9-15.4a8.4 8.4 0 0 0-3.6-1.2v-.3c0-4.5-3-9.9-7-12a6.4 6.4 0 0 0-2.9-1A34.6 34.6 0 0 0 30.5 2.3a14 14 0 0 0-7-2.3c-3.9 0-6.8 2.3-8 6.4a18 18 0 0 0-4.8-4z",
    fill: "url(#home-devops-landscape_svg__n)",
    mask: "url(#home-devops-landscape_svg__o)",
    transform: "matrix(-1 0 0 1 287 12.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5 61.8c0 1.3-.1 4.8-2.4 3-2-1.6-1.9-7.2-.5-10l.9-1-.1.6a9 9 0 0 0-.6 4.7c.1 1.4 1.2 4.1 2.7 2.3v.4",
    fill: "#79409f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 55.3c-.3.8-.6 1.5-.6 2.4a2.8 2.8 0 0 1-.1-.4v.9l.2 3.2c-1.5 1.8-2.6-.9-2.7-2.3a9.1 9.1 0 0 1 .5-4.7l.2-.6.5-2.9c.5 0 1.2.5 1.7 1v-.1l.5 2.5z",
    fill: "#fbbeab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7 1C11 2.2 4.5 4.7 2 4.8L0 3.4C2.5 3.4 7.7 2 7 .2c1.2-.1 3.4-.3 3.6.7",
    fill: "#79409f",
    mask: "url(#home-devops-landscape_svg__p)",
    transform: "rotate(70 109.9 245.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8 58.5a98 98 0 0 1-.9-5.1c1-1.5 3.3-1 4.6-.3a482.5 482.5 0 0 0-1.2 6c0 1.8 1.7 3.9 2.4 5.1l.3.7c-1.4 1.1-4.6-3.3-5.5-5.5l.3-1",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 50.6c0-2.1-.8-4.1 1.7-9.4l-.9-3.3 1.6 1 4 2.6c.7 1.9.2 3.8 0 5.7L300 49l-1.2 6.3c-1.3-.8-3.6-1.2-4.6.3a36.3 36.3 0 0 1-.2-5",
    fill: "#f0849f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(70 137.9 229.3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__q)",
    xlinkHref: "#home-devops-landscape_svg__r"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#f0849f",
    xlinkHref: "#home-devops-landscape_svg__r"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 33)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f0849f",
    xlinkHref: "#home-devops-landscape_svg__s"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__t)",
    fillOpacity: 0.7,
    xlinkHref: "#home-devops-landscape_svg__s"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 33)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f0849f",
    xlinkHref: "#home-devops-landscape_svg__t"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__u)",
    fillOpacity: 0.7,
    xlinkHref: "#home-devops-landscape_svg__t"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 33)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f0849f",
    xlinkHref: "#home-devops-landscape_svg__v"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__w)",
    fillOpacity: 0.7,
    xlinkHref: "#home-devops-landscape_svg__v"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 33)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f0849f",
    xlinkHref: "#home-devops-landscape_svg__u"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__x)",
    fillOpacity: 0.7,
    xlinkHref: "#home-devops-landscape_svg__u"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 33)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f0849f",
    xlinkHref: "#home-devops-landscape_svg__y"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__z)",
    fillOpacity: 0.7,
    xlinkHref: "#home-devops-landscape_svg__y"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 33)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f0849f",
    xlinkHref: "#home-devops-landscape_svg__w"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__A)",
    fillOpacity: 0.7,
    xlinkHref: "#home-devops-landscape_svg__w"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 33)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f0849f",
    xlinkHref: "#home-devops-landscape_svg__B"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__C)",
    fillOpacity: 0.7,
    xlinkHref: "#home-devops-landscape_svg__B"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280 33)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#f0849f",
    xlinkHref: "#home-devops-landscape_svg__x"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__D)",
    fillOpacity: 0.7,
    xlinkHref: "#home-devops-landscape_svg__x"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.8 8.9c-.4 2.2-4 4.3-5.8 3.5.5-.3 1.2-.5 1.4-1a3 3 0 0 1-1 .2c.8-.2 1.4-1.2 1.4-2 0-1.3-.8-2.5-1-3.8a5.8 5.8 0 0 1 2-4.8A4.3 4.3 0 0 1 5 0l-.7 1.4a7.7 7.7 0 0 0 .3 5c0 .6.2 1.1.5 1.6l.8.9",
    fill: "#a572b8",
    mask: "url(#home-devops-landscape_svg__E)",
    transform: "translate(274.8 3.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.6 12.4c.5 0 1 0 1.5-.2h.1v1.2h.1v.2h-.2a2.7 2.7 0 0 1-1.6-.3 2.6 2.6 0 0 1-.3-.2 1.4 1.4 0 0 0 0-.3v-.5z",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#home-devops-landscape_svg__z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__F)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280 5.4c-.6 2.2-1 4.6.6 6.4v.5a2.8 2.8 0 0 1-.8-1c-.3-.4-.4-.9-.5-1.5V7.5l.1-.5.1-.3v-.2c.3-1 .7-2 1.2-2.9h.2l-.9 1.8",
    fill: "#af7fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.3 41.3-3.8 3-1.5 1.2-.8-.1-.1-.2.7-.6.5-.4 6-4.7.6.6z",
    fill: "#274780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.8 9.4a.7.7 0 0 1 0-.2v.2zm1.7-2h-.5zm0 0v.1c-.1.9-.4 2.3-.4 3.4v.1l-.1.2-.3.5-.4-.2c0 .2-.2.4-.3.5-.1.3-.3.4-.5.6l-.1.2a.8.8 0 0 0-.1.2h-.2l-.9-.6-.6-.6c-1.5-1.8-1.2-4.2-.6-6.4.2-.6.5-1.2.9-1.7 1-1.3 2.4-2.5 4-2.5h1.5c1.1.2 2.7.5 3.7 1.3l1 1 .1.5.4 1.1v1.6a8.8 8.8 0 0 1-.8.4l-.5.2a7.7 7.7 0 0 1-2.6.5l.5-.7-3.6.3zm-.9 2.3v-.2.2z",
    fill: "#a572b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.2 32.6h.1c-.9.2-2.4 2-2.3 3a17.5 17.5 0 0 1-2.8-2l-.4-.2-.3-.3-.4-.3-.2-.2-.4-1a27 27 0 0 1-1.3-4.7c-.6-2.7-1.4-5.5-1.3-7.5 0-1.2 0-2.8.6-3.1h.1c.4 0 1.7.2 2.2 1l.6.9v.1l.2.3a8.3 8.3 0 0 1 .3 1.2c.5 1.9.7 4.2 1 6.2v.9l.3 1.8v.4l.3.7c.9.3 1.7 1 2.5 1.7l1.2 1z",
    fill: "#7d61be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.2 42.2.4.2 2.8 1.2 3.5 1.6.7.3.5-.3.1.2h.8l-.1.2-.2.1-.6.5-.4.3-1.6-.8-.4-.2-7-3v-.2h-.1v-.7l1.6.6z",
    fill: "#274780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.2 39.5-5.9 4.7-.5.4-.7.6-.5.3.4-1.4.5-2.4.2-.7v-.5l.1-.3.2-.8.6-2.5.2-.8v-.4l.1-.2.2-.7.3-.2 8.8-6.7 2.5-1.9.1-.1-1.3 5.1-1.4 5.5-3.2 2.5z",
    fill: "#5a8dcf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 25.8s.8-.3.7.2l-2.5 1.9-8.8 6.7-.3.2-.2.7v.2l-.1.4-.2.8-.6 2.5-.2.8v.3l-.1.5-.2.7-.6 2.4-.3 1.4-.8-.3.3-1.2.1-.6.4-1.5.2-.7v-.5l.1-.3.3-1.4.1-.2.3-1.2.2-.9v-.1l.1-.7.1-.3v-.3h.1l.1-.5v-.2l.6-.4 1-.8.6-.4 7.5-5.7 2-1.5zm-2 10.7c.3.4.3.9.3.9l-2.7 2-.7.6-.7-.5.7-.5 3.2-2.5z",
    fill: "#274780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.8 34.3-.6.4v.1l-.1.5h-.8l.7.3v.3l-.2.7-.8-.4a3.7 3.7 0 0 1-.9-.7l-.5-.6.3-.5.8-.8.2-.2c.7.2 1.3.6 1.8.8z",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8 36.6v.1l-.3 1s-.2 0-.3.2c-.3 0-.6.2-.8.4l-2-.9c.9-.3 1.7-1 2.6-1.2l.7.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.6 37.6-.3 1.2v-.1a2.9 2.9 0 0 0-.5-.2l-.4-.2.7-.4.5-.3",
    fill: "#d2e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.3 39-.7 2.9c-.4-.3-.7-.8-1-1.3a2 2 0 0 0-1-.5c-.2 0-.3 0-.5-.2l-.5-.2a4.1 4.1 0 0 1-1.6-.8l-.3-.2c0-.7 0-1.4.7-1.8a17.8 17.8 0 0 1 4 1.4c.1 0 .3 0 .4.2l.4.2h.1zm-.3-5.6-.3.2-.8.8-.3.5-.4-.4-.6-.6-2.5-3c.6-.8 1.5-1.5 2.3-1.6l.3.5c.7 1.1 1.2 2.4 2 3.3l.3.3",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.6 41.9-.3 1.5h-.2a62.5 62.5 0 0 0-4.2-2.1 34 34 0 0 0 2.2-1.4l.5.2 1 .5c.4.5.6 1 1 1.3",
    fill: "#d2e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.3 43.4-.2.7-.3 1-3.4-1.5-2.8-1.2-.4-.2-1.6-.6 4.4-2.7c.5.4 1 .7 1.6.8l.5.2-2.2 1.4 4.2 2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.8 26.3c.8.5 1.2 2 1.6 3-.8.1-1.7.8-2.3 1.6-1-1.4-1.8-2.7-2-3.5v-.7a.6.6 0 0 0 .2-.2l.2-.7 1-2.6.2-.2.5-1.5c0 1.9 0 3 .6 4.7",
    fill: "#7d61be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.4 19.3v1.2a9.2 9.2 0 0 1-.7 2.5l-.1.2c-.4 1-.8 1.8-1 2.6l-.3.7-.1.2-.1.7c-.3 2-.3 4.9 2 5.2v.6l-.8.9-.5-.2c-.6-.3-1.1-.6-1.8-.8a3 3 0 0 1-.2-.5 3.6 3.6 0 0 1-.2-1.8l.5-2.3.2-2.3.6-1.8v-.3a8 8 0 0 0 .5-2.1c0-1.5-.2-3.1-.7-4.6l-.2-.5.6-.1c-.7-.6-.9-1.7-1.4-2.4a9.6 9.6 0 0 0-.6-1 3.6 3.6 0 0 0-.5-.7 4.1 4.1 0 0 0 1.8-.2 5 5 0 0 1 .8 2v.1l.6 1.3v.1l.2.3.5.8a10.5 10.5 0 0 1 .7 1.3l.2.9",
    fill: "#7d61be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.4 36.9c-.6.4-.7 1-.7 1.8l-.7-.2a21 21 0 0 1-3.6-1.2l-.5-.2a30 30 0 0 1-3-1.5c0-1 1.5-2.9 2.4-3l.2.2a14.7 14.7 0 0 0 .9.8l2 1.5.5.4a11.7 11.7 0 0 0 2.5 1.4",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.1 33v.2z",
    fill: "#559ca1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.9 17.1.1 1a10.6 10.6 0 0 0-1-1.8l-.2-.3a6.4 6.4 0 0 0-.7-1.4 5 5 0 0 0-.7-2l.5-.3c1.4.7 1.5 2.2 1.9 3.7l.1 1",
    fill: "#7d61be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.8 33.9.5.2a6 6 0 0 1-.8.5c-.6-.4-1.1-.9-1.5-1.5l1.8.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.7 11.7-.2.2a1.8 1.8 0 0 0-1.2-.8 2.7 2.7 0 0 0 .3-.6l.2-.3V10c0 .7.2 1.3.9 1.5",
    fill: "#af7fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.7 17.4c.5 1.5.7 3 .7 4.6 0 .7-.2 1.4-.4 2v-2.9a8 8 0 0 0-2-3.7v-.2l1.5-.3.2.5z",
    fill: "#7d61be"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#af7fc0",
    xlinkHref: "#home-devops-landscape_svg__G"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__H)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.1 7v.4l-.3 2.7-.1.4a3.1 3.1 0 0 1-.4.6h-.8l.5-1v-.3c.2-.4.3-1 .3-1.4v-1l.5-.3h.2z",
    fill: "#af7fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3 11.1c.5 0 .9.3 1.2.8a2.4 2.4 0 0 1-1.1.6 6.9 6.9 0 0 0-.7-.7l.6-.7",
    fill: "#af7fc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#home-devops-landscape_svg__A"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__I)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291 16.8h-.5a6.5 6.5 0 0 0-.2-.5c-.3-.7-.6-2-1.2-3l.7 1c.4.8.6 2 1.3 2.5",
    fill: "#fabba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.5 16.9-1.5.3-.3-.3v-.1h-.1a5.4 5.4 0 0 0-.5-1.4l.8.5c.4-1.4.2-2.2-.4-3v-.2l.6.6c.6 1 1 2.3 1.2 3l.2.6",
    fill: "#fabba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3 8.2v.2c0 .5 0 1-.2 1.4l-.1.2-.5 1.2h-.5l-.9.3c0 .2-.2.3-.4.5l-.5.2a2.6 2.6 0 0 1-1.6.2 2.8 2.8 0 0 1-.4-.1v-.7c.2-.8 0-1-.2-1.7V9l.3-.5v-.9a8.8 8.8 0 0 0 4.5 0l.5-.3v1",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#af7fc0",
    xlinkHref: "#home-devops-landscape_svg__J"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__K)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__J"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#af7fc0",
    xlinkHref: "#home-devops-landscape_svg__C"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__L)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m289.5 11.2-.2.3-.1-.1-.2-.2h.4",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#af7fc0",
    xlinkHref: "#home-devops-landscape_svg__M"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__N)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__M"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#home-devops-landscape_svg__D"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__O)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.2 11.4h.1l-.5 1-.1.2h-.1a2.2 2.2 0 0 0-.5-.4l-.4-.2.4-.5.9-.3z",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289 17.2-.8.3-.1-.3.2-.3a.6.6 0 0 1 .3-.1zm-.5-4.3c.6.8.8 1.6.4 3l-.8-.5-.6-.3a9.2 9.2 0 0 1-.9-.5l.7-1a1 1 0 0 0 .3-.1l.6-.4.3-.2",
    fill: "#fabba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289 13.3-.4-.6.5.6",
    fill: "#8eb50a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.6 12.6zm0 .1-.1.2-.5-.7-.3-.2c.2 0 .3 0 .4.2.2 0 .3.2.5.4z",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.1 15.4.5 1.4a.6.6 0 0 0-.3.1.8.8 0 0 0-.1.3c-.5-.6-1.3-.7-1.8-1.2l.2-1.4.9.5.6.3",
    fill: "#fabba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.5 12.8-.3.3-.5.4h-.4v-1.4l.4-.2.3.2.5.6",
    fill: "#fbccbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.1 17.2.1.3h-.3c-1 .4-2 1-2.6 1.6l-.4-.2c-.7-.8-1.5-1.4-2-2.4l2.7 1.9.8-2.4c.5.5 1.3.7 1.8 1.2z",
    fill: "#fabba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 42-.5-.3z",
    fill: "#b41b06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.8 37h.1c-.9.3-1.7.7-2.5.7h-.5a8 8 0 0 1-.5 0l-.2-.1a9.3 9.3 0 0 1-2-.5l-1.7-1-.6-.3c.5-1 1-2 1.2-3l.4.3.3.3.4.2.8.7a20.3 20.3 0 0 0 2.6 1.6l2.2 1.1",
    fill: "#7d61be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.2 7-.5.8a8.8 8.8 0 0 1-2.3-.2l-.1 1a2.6 2.6 0 0 0-.3 1.3c.1.6.4 1 .3 1.7l-.1.7a5 5 0 0 1-.6-.3l-.3-.1-.2-1c.3-.5.5-1 .6-1.7l-.1-1.7 3.6-.4",
    fill: "#fabaa9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.1 13.6h.2c0 .3-.4.7-.7 1a2.7 2.7 0 0 1-1.4.5 2.6 2.6 0 0 1-.3-.6 5.3 5.3 0 0 1-.4-1.5l.3-.1.3.2.4.2c.5.2 1 .4 1.6.3z",
    fill: "#fabba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.6 14.5-.2 1.4v.1l-.8 2.4c-.6-.5-1.8-1.1-2.6-2l-.1-.2a8.3 8.3 0 0 1-.4-1.6v-1 .7c.4.5 1 .7 1.6.8a4.5 4.5 0 0 0 1.6-.1 3 3 0 0 0 .8-.4z",
    fill: "#fabba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.4 37.7h-1 .5z",
    fill: "#8eb50a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3 19.1v.1l-.4-.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2 12.3v.4c-.3 0-.5-.2-.7-.4V12c.3 0 .4.2.6.3h.1m0 .6v.2l-.4-.2.4-.1z",
    fill: "#fabaa9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a572b8",
    xlinkHref: "#home-devops-landscape_svg__P"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__Q)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__P"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.6 13.2h.1c.8.2 1.3 0 1.9-.2l.3 1.5.3.6h-1c-.7 0-1.3-.3-1.7-.7v-1.3a.6.6 0 0 0 .1 0",
    fill: "#fabba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.6 12.7.2.2h-.3a3 3 0 0 1 0-.3h.1z",
    fill: "#a572b8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#af7fc0",
    xlinkHref: "#home-devops-landscape_svg__R"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__S)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__R"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.5 7.4v.1zm0 4.6v.3a1.4 1.4 0 0 1-.2-.4h.3",
    fill: "#fabaa9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5 12.6v.4c-.5.2-1 .4-1.8.3l-.1-.1v-.3h-.2v-.1l.7-.5.4-.4.8.5.2.2",
    fill: "#af7fc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a572b8",
    xlinkHref: "#home-devops-landscape_svg__F"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__T)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.4 7.4h-.4z",
    fill: "#b41b06"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.8 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#af7fc0",
    xlinkHref: "#home-devops-landscape_svg__U"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__V)",
    fillOpacity: 0.3,
    xlinkHref: "#home-devops-landscape_svg__U"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.9 18.9a7.2 7.2 0 0 1-1.6-1.5 3.5 3.5 0 0 1-.6-1.1 3.5 3.5 0 0 0 .2.2c.5 1 1.3 1.6 2 2.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7 9.7v-.2.2",
    fill: "#b41b06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.7 11.7-.2.2-.4.4-.6.5a1.1 1.1 0 0 0-.1 0l.1-.2.5-.6.3-.5.4.2",
    fill: "#af7fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.8 16.3.1.2-.2-.2a8.3 8.3 0 0 0 .1 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.9 9.4a.5.5 0 0 1-.1-.2v.2",
    fill: "#b41b06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.6 12.9v.3a4.8 4.8 0 0 0-.5-.3h.5",
    fill: "#a572b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.8 26c-.2-2-.4-4.3-1-6.2a8 8 0 0 0-.2-1l.3.7c.5 1.9.7 4.4 1 6.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9 19.5a7.5 7.5 0 0 0-.4-1.2l.4 1.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5 18.3v.3-.3",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.4 18.2-.6-.8c-.5-.9-1.8-1-2.2-1.1h.6c.9.3 1.2.4 1.7 1 .2.1.4.6.5.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.7 3.6c-.5.9-.9 1.9-1.1 2.9v.2l-.1.2V7l-.1.4v2.5l-.2-.5a7.7 7.7 0 0 1-.1-4.5c.1-.5.4-1 .6-1.3l1 .1",
    fill: "#af7fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2 37.3v-.6z",
    fill: "#b41b06"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.5,
    cy: 463.5,
    fill: "#9787ff",
    rx: 5.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183 192.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m455.7 133.3-.4 3a67.9 67.9 0 0 1-1.2 6.4l-.8 3.3a85.8 85.8 0 0 1-2 6.4 87.1 87.1 0 0 1-3.9 9.3 100.7 100.7 0 0 1-5.8 10.2l-1.6 2.4a117 117 0 0 1-3.2 4.4l-1.4 2a125.9 125.9 0 0 1-6 6.8l-1.6 1.8a139.7 139.7 0 0 1-5.2 5.1l-2.5 2.3a161.2 161.2 0 0 1-10 8.3 200.7 200.7 0 0 1-7.2 5.3 171 171 0 0 1-3.6 2.4l-4.2 2.7-5.3 3.2a233.8 233.8 0 0 1-19.5 10c-4.8 2.2-9.7 4.3-14.6 6.3l-2 .8a290.1 290.1 0 0 1-16.4 5.6c-3.8 1.2-7.8 2.3-11.7 3.3l-9 2.4c-4.1 1-8.4 1.9-12.6 2.7-3 .7-6 1.4-9.2 1.9l-3.8.6c-5.2.9-10.5 1.6-15.8 2.2l-4.6.6c-6.2.7-12.3 1.2-18.6 1.6l-3.4.1-12.5.4a385.3 385.3 0 0 1-34.5-.9 383.6 383.6 0 0 1-44.2-5.7L145 248l-3-.7a330.1 330.1 0 0 1-17.2-4.6l-4.8-1.5c-4.7-1.5-9.3-3-13.8-4.7l-4-1.5c-4.2-1.6-8.2-3.3-12.2-5l-5.9-2.6a236.1 236.1 0 0 1-16.7-8.7c-45-26-67.4-60-67.3-94L0 150.6c-.1 34 22.4 68.1 67.3 94 5.4 3.2 11 6 16.7 8.8 2 1 4 1.7 6 2.6 3.3 1.5 6.7 3 10.2 4.4l1.8.7 4 1.5a294.4 294.4 0 0 0 13.8 4.7l4.9 1.5 3.2 1a286 286 0 0 0 14 3.6l3 .7 6.8 1.5 5.6 1c4 .8 8 1.5 12.1 2.1l4.8.8 5.4.6c3.8.5 7.6 1 11.4 1.3l5.4.6 5.1.3c3.9.3 7.7.5 11.6.6 2 0 3.8.3 5.8.3h23.3l6.4-.4a389.7 389.7 0 0 0 19-1.4c1 0 1.9-.2 2.9-.3l4.6-.6a374.2 374.2 0 0 0 15.8-2.2l3.9-.6 1.8-.3 7.3-1.6c4.3-.8 8.5-1.7 12.7-2.7l9-2.4c3.9-1 7.8-2.1 11.7-3.4l2.5-.7c4.7-1.5 9.3-3.1 13.8-4.9l2-.8a260.9 260.9 0 0 0 18.8-8.2 230.6 230.6 0 0 0 18.1-9.7 227.2 227.2 0 0 0 6.6-4.2l3.7-2.5a176.6 176.6 0 0 0 10.8-8 162.1 162.1 0 0 0 6.5-5.5l1.3-1.2 1.2-1.1 5.1-5.1 1.7-1.8c2-2.2 4-4.5 5.9-6.9l.2-.3c.5-.5.8-1 1.2-1.6l3.3-4.4 1.5-2.4 2.5-4 .7-1.2.9-1.7a107.4 107.4 0 0 0 3-6.3c.6-1.1 1-2.3 1.5-3.4l.7-1.5.5-1.4a79.3 79.3 0 0 0 2-6.4l.7-3.3.5-1.8.2-1.2a87.5 87.5 0 0 0 1.1-9.9l.2-2V126v4c-.2 1.1-.2 2.3-.3 3.4z",
    fill: "#544e99",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__H)",
    xlinkHref: "#home-devops-landscape_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#home-devops-landscape_svg__d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.2 202.3 33.5 242a.5.5 0 0 0-.2.7.5.5 0 0 0 .7.1l68.7-39.6a.5.5 0 0 0 .1-.7.5.5 0 0 0-.4-.2.5.5 0 0 0-.2 0M406.8 20 338 59.7a.5.5 0 0 0-.2.6c.1.2.3.2.4.2h.3l68.7-39.7a.5.5 0 0 0 .1-.6.5.5 0 0 0-.4-.3.5.5 0 0 0-.2 0",
    mask: "url(#home-devops-landscape_svg__W)",
    stroke: "#c8c9ea",
    strokeWidth: 6.2
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#home-devops-landscape_svg__W)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638 .8c-1 .6-1.3 1.5-.8 2.2l-76.6 44v56L542 113.7v60.6l-73.2 44.3-10-5.7 58.7-35.9v-33.2l-.2-.2-56.1-32.3v-11.2l31.7-18.3c1.4.6 3.3.5 4.5-.2 1.4-.8 1.4-2 0-2.9a5.5 5.5 0 0 0-5 0c-1.2.7-1.3 1.8-.3 2.6l-31.7 18.3v12.2h.2l56 32.4v32.4L458 212.4l-4-15.1v-24.1l25-14.5V142l-.1-.1-53-30.5c1-.8 1-1.9-.3-2.6a5.5 5.5 0 0 0-5 0c-1.3.8-1.3 2 0 2.8 1.3.7 3.2.8 4.6.2l53 30.6v15.8l-24.3 14-.8 24.6-9.3-5.4-15.4 9-14-8.1v-19.6l-.2-.1-37-21.3V133c.8 0 1.6-.3 2.2-.6 1.3-.8 1.3-2 0-2.8a5.5 5.5 0 0 0-5 0c-1.4.7-1.4 2 0 2.8.6.3 1.3.5 2.1.6v18.9h.2l37 21.4v18.6l-60.2-34.6v-36.7l32.6-18.8h30L467.4 72c1.4.5 3.3.5 4.5-.2 1.4-.8 1.4-2.1 0-2.9a5.5 5.5 0 0 0-4.9 0c-1.2.7-1.3 1.8-.4 2.6l-50.8 29.3h-28.3l94.3-54.3c1.3.5 3.2.5 4.5-.2 1.3-.8 1.3-2.1 0-2.9a5.5 5.5 0 0 0-5 0c-1.2.7-1.3 1.8-.3 2.6l-128.3 74v37.5l.2.1 74.7 43-15 8.7L285 136V92h-.2l-43.3-25c1-.8.8-2-.4-2.7a5.5 5.5 0 0 0-5 0c-1.3.8-1.3 2.1 0 2.9 1.3.7 3.2.8 4.6.2l43.5 25.1v43.8l.2.1L411.8 210l-14.3 8.2-126-72.6h-75.2l-47-27V76.7c.5 0 1-.3 1.3-.5 1.4-.8 1.4-2 0-2.8a5.5 5.5 0 0 0-4.9 0c-1.4.8-1.4 2 0 2.8.8.5 1.8.6 2.8.6v42h.2l47.3 27.4h75.2l106.4 61.3h-21.4l-36.3-21h-28v.1L237 225.1a5.5 5.5 0 0 0-4.5.2c-1.3.8-1.3 2 0 2.8 1.4.8 3.6.8 5 0 1.2-.7 1.3-1.8.3-2.6l54.3-38h27.6l36.3 20.9h23l17.7 10.2-38.2 22-10.9-6.3V218l-27.5-16c1-.8.8-1.9-.4-2.6a5.5 5.5 0 0 0-5 0c-1.3.8-1.3 2 0 2.8 1.3.8 3.2.8 4.6.2l27.6 16v15.5l-29.4-17h-14l-16.7 9.6a5.5 5.5 0 0 0-4.5.2c-1.4.8-1.4 2.1 0 2.9 1.4.8 3.6.8 5 0 1.2-.7 1.3-1.8.3-2.6l16.1-9.3h13.5l40.5 23.3-7.3 4.3 23.4 13.5-11 6.3h-16.6l-11.9-6.8c1-.8.9-1.9-.4-2.6a5.5 5.5 0 0 0-5 0c-1.3.8-1.3 2 0 2.9 1.3.7 3.3.7 4.7.1L346 266h15.5l-28 16.2-66-38H220l-26.7 15.4a5.5 5.5 0 0 0-4.5.2c-1.4.8-1.4 2 0 2.9 1.3.8 3.5.8 5 0 1.1-.7 1.3-1.9.3-2.6l26.2-15.2h47l50.9 29.3h-21.8L275.1 262c1-.8 1-1.9-.3-2.6a5.5 5.5 0 0 0-5 0c-1.3.8-1.3 2 0 2.8 1.3.7 3.2.8 4.5.2l21.9 12.6h23.3l13.2 7.6-33.5 19.3h-107l-83-47.9c1-.8.8-1.9-.4-2.6a5.5 5.5 0 0 0-5 0c-1.4.8-1.4 2 0 2.9 1.2.7 3.2.7 4.5.2l83.7 48.2h105.8l-13.2 7.6 90-51 10 5.8-94.4 54.4h-69l-83.4 48H22.3L0 354.7v.9l22.1 12.7h116l52.3-30.2V356l-34.5 19.9a5.5 5.5 0 0 0-4.5.2c-1.4.8-1.4 2 0 2.8s3.6.8 5 0c1.2-.7 1.3-1.8.3-2.6l34.5-19.9v-18.6h-.2l30.4-17.5h69l.1-.1 94.9-54.7 11.3 6.6-184 106v19.2h.7v-18.7l184-106 14 8-94.9 54.7v9.8l-16.8 9.7v22.5L267.1 396a5.5 5.5 0 0 0-4.6.2c-.5.3-.8.6-.9 1h6.8c0-.3-.3-.5-.6-.8l32.7-18.8v-22.5l16-9.2v36l9.5 5.5-17 9.8h1.5l16.3-9.4 16.3 9.4h1.5l-27.3-15.7v-45.8l95-54.8 12.7 7.4-67.2 38.7a5.5 5.5 0 0 0-4.5.2c-1.4.8-1.4 2 0 2.9 1.3.7 3.6.7 5 0 1.2-.8 1.3-1.9.3-2.6l67.2-38.8 5.7 3.3 6.5 3.8-80.3 46.3h-21.8a2 2 0 0 0-1-1 5.5 5.5 0 0 0-5 0c-1.3.8-1.3 2 0 2.8 1.4.8 3.6.8 5 0a2 2 0 0 0 1-1h22l81-46.6 4.9 2.8 3.8-2.2 19.3 11.1v15.5l-16 9.1h-25l-27.4 15.8a5.5 5.5 0 0 0-4.5.2c-1.4.8-1.4 2.1 0 2.9 1.4.8 3.6.8 5 0 1.2-.7 1.3-1.8.3-2.6l26.9-15.5h23.5l-46.8 27a5.5 5.5 0 0 0-4.6 0c-1.4.9-1.4 2.1 0 3 1.4.7 3.6.7 5 0 1.1-.8 1.3-1.8.4-2.6l58.3-33.6v7.4l-34.7 20v14.1L399 385a5.5 5.5 0 0 0-4.5.2c-1.3.8-1.3 2 0 2.9 1.4.7 3.6.7 5 0 1.2-.8 1.3-1.9.3-2.6l28.3-16.3V355l34.7-20v-8.3l4.8-2.8v-16.3l-19.2-11.1 12.6-7.3 39.7 22.8v26l-27 15.5a5.5 5.5 0 0 0-4.6.1c-1.3.8-1.3 2.1 0 2.9 1.4.8 3.6.8 5 0 1.2-.7 1.3-1.8.4-2.6l26.2-15v21L480 371.6v25.5h.8v-25l19.9-11.5v36.5h.7v-85.6l-39.6-22.9 6.8-12.8 59.2 34.5v71l24.9 14.4v1.4h.8v-1.9l-25-14.3v-71l-59.1-34.6 18-1.4 69.8 40.3v60.6l38.7 22.3h1.5L558 374.5v-60.7l-69.9-40.2 17-9.9 103.5 29 .2-.9L506 263.3l19.8-11.4 42.6 24.5h68.3l24.6 14.2v-1l-5.4-3-1.4-.8-17.6-10.2h-68.3l-12-6.9h29.3l14.6-8.4H661l.2.1 13-.9h-72.6L618 250c1.4.6 3.3.6 4.6-.2 1.3-.7 1.3-2 0-2.8a5.5 5.5 0 0 0-5 0c-1.2.7-1.3 1.8-.3 2.6L585.5 268h-30.2l-28.7-16.6 10.6-6.1-6.8-4h19.8l26 15c-1 .8-.9 1.9.3 2.6 1.4.8 3.6.8 5 0s1.4-2 0-2.9a5.5 5.5 0 0 0-4.5-.2l-26.6-15.2H529l-14.5-8.4 9-5.2h15.8l13.9-8h10.4l.2-.8H553l-14 8h-14.2l28.5-16.4h15.5l34.1 20.5h60.4v-.8h-60.2L569 209h-16l-39.4 22.7-10.3-6 44.4-26.5h31.4l25.8 15.9h55.4v-.8h-55.2l-24.5-15h80.6v-.8H547.6l-45 26.8-11.7-6.7-.8-.5-20.6 1 73.2-44.3V114l118.6-68.3v-1l-99.9 57.6V47.6l76.5-44h.1c1.4.8 3.6.8 5 0s1.3-2 0-2.8a5.5 5.5 0 0 0-5 0z",
    fill: "url(#home-devops-landscape_svg__I)",
    transform: "translate(-207 -133.3)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M572.5 254.2v8c-.3 1-1.4 2-3.3 3L524 291.5c-3.3 2-8.4 2.2-11.2.5l-47-27.3c-1.3-.8-2-1.5-2.3-3a43 43 0 0 1 0-7.5h36.8l11.6-6.8c3.4-2 8.4-2.2 11.3-.5l12.5 7.3z",
    fill: "hsla(0, 0, 100%, 1)",
    stroke: "#afabde",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512.7 285.3-47.4-27.6c-2.9-1.7-2.5-4.7.9-6.6l45.7-26.7c3.3-2 8.4-2.2 11.3-.5l47.4 27.6c2.9 1.7 2.5 4.7-.8 6.6L524 284.8c-3.3 2-8.4 2.2-11.3.5",
    fill: "currentColor",
    stroke: "#a8a3e8",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.7 240.8a3.3 3.3 0 0 0-1.5-.4 2.9 2.9 0 0 0-1.5.4l-.3.2-.7.5a1 1 0 0 1-.4.3c-.7.6-1.5 1-2.3 1.5l-1 .2-.7.3-2.8-1.2a38.4 38.4 0 0 0-13.8-2.1l-.1-.4-.4-.2c-.2 0-.3-.2-.3-.3a6.1 6.1 0 0 1-.2-2v-1.2a1.3 1.3 0 0 0-.6-.9 2.3 2.3 0 0 0-1.5-.2c-1.1 0-1.8.7-1.7 1.3s0 .2 0 .2l.4.7.2.4c.3.7.6 1.3.6 2 0 .1-.1.3-.4.4v.5h-.5a30 30 0 0 0-14.2 5.4l-.7-.3h-1.1l-2.9-1.1a1.5 1.5 0 0 0-.5-.2l-.9-.5-.4-.1h-.2c-.9-.4-2.1-.3-2.7.2-.5.5-.3 1 .2 1.4h.2l.4.2h.2l.2.2 1.1.2.6.2a24 24 0 0 1 3 1h.1l.4.5v.1l.7.3c-2.2 2.5-3.1 5.3-2.4 8.1 0 .7.3 1.3.6 1.9h-.9v.1c0 .2-.3.4-.6.5l-3.2.5-.7.1-1.2.1h-.4s0 .1-.1 0c-1 .3-1.6 1-1.4 1.5l.4.4a4 4 0 0 0 2.2.3h.5l1-.4.6-.1c1-.4 2.1-.6 3.2-.8l1 .1h.1l.9-.2a16.7 16.7 0 0 0 5 4.2 22.9 22.9 0 0 0 4.4 2l3 1-.3.4c.2.2.2.4.2.6-.4.6-.7 1.2-1.3 1.8l-.4.4-.5.6v.2s-.1 0 0 0c-.2.5-.1 1 .5 1.3.2.2.4.2.7.3l1.4-.1c.4-.2.8-.4 1-.7v-.2l.3-.7v-.4h.2c.1-.7.5-1.4 1-2 0 0 .3-.3.7-.3h.1l.4-.4c5.8.8 12 .4 17.4-1.2l.5.4h.1c.3 0 .6 0 .8.2.7.6 1.3 1.1 1.7 1.7l.4.4.4.6s0 .2.2.2v.2l.4.2a3.5 3.5 0 0 0 2.4.2c.7-.4.7-1.1.2-1.5 0 0-.1-.1 0-.2s-.1 0-.3-.2l-.8-.5-.3-.3h-.1a14.5 14.5 0 0 1-2-1.7.4.4 0 0 1 0-.5l-.4-.4a23 23 0 0 0 6-3.8 13 13 0 0 0 3.2-4.8h.9c.3-.1.6-.3 1-.3 1.1 0 2.2.2 3.3.4h.7l1.2.3h.5c1.1 0 2.1-.4 2.3-1 0-.3-.2-.7-.5-.9-.4-.2-.9-.3-1.4-.3h-.1l-.4-.1h-5.1l-.6-.2-.2-.2-1-.2-.1-2a13 13 0 0 0-5.6-7.4l.5-.4c-.1-.2 0-.3.1-.5l2.6-1.3.6-.2 1-.4.4-.3c.8-.4 1-1.1.3-1.5l-.2-.1m-22.1 8.8c-.3-.1-.3-.3-.5-.4l-1.7-5.8c3.6 0 7.2.6 10.2 1.7l1.8.7-7.5 3.8c-.6.4-1.7.4-2.3 0m6.6 3.7c-.4-.2-.6-.5-.5-.8 0-.1 0-.3.3-.4l6.7-4.3c2.8 2 4.2 4.3 4.3 6.8l-10-1a2.4 2.4 0 0 1-.8-.3m3.6 10.1-4.9-5c-.5-.4-.2-1 .6-1.3h.8l10.2.2a10 10 0 0 1-2.5 3.4 16.2 16.2 0 0 1-4.2 2.7M502 247.5c2.7-1.8 6.5-3.2 10.7-3.8l.6 5.7c0 .6-.6 1-1.5 1h-1zm12.9 8.6-1-1.6 1.5-1.5 3.1-.2 2.1 1.2-.3 1.8-2.6.9zm-1.7 9.6 4-5.5c.3-.4 1.2-.5 2-.4l.7.3 6 4.8a33 33 0 0 1-12.6.8M498 257a7 7 0 0 1 1.5-7.2l8.3 3.4c.5.3.7.8.2 1.2 0 .2-.4.3-.7.4L498 257m5.5 5.6a16.6 16.6 0 0 1-3.8-3l9.8-1.6c.5 0 1 0 1.3.2l.4.4v.6l-2.7 5.6-1.6-.6a22.9 22.9 0 0 1-3.4-1.6m9.2-22.4z",
    fill: "#7362c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268 255.8-.6-194.2c.3-4-.8-6-3.4-6m19.9 192.2-.6-194.3a11 11 0 0 0-.6-4.5c-.6-1-1.5-1.4-2.8-1.4m-11.6 139 15-8.8m-15 15.8 15-8.8m-15-5.7 14.9-8.8m-15 1.4 15-8.8m-15 1.4 14.9-8.8m-14.8 68.1 15-8.8m-15 15.9 15-8.8m-15-5.7 14.9-8.8m-14.9 37.4 15-8.8m-15 15.8 15-8.7m-15-5.7 14.9-8.8m-15-19.8 15-8.8m-15 1.3 14.9-8.7m-15-35.8 15-8.7m-15 1.3 15-8.8m-15 1.4 14.9-8.8m-15 1.4 15-8.8m-15 1.3 15-8.7m-15 1.3 14.9-8.7m-15 1.3 15-8.8m-15 1.4 15-8.8m-15 1.3 14.9-8.7m-15 1.3 15-8.7m-15 1.3 14.9-8.8m-15 1.4 15-8.8m-15 1.4 15-8.8",
    stroke: "#a9b3e5",
    strokeLinecap: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.7 273.6V305v-31.3z",
    fill: "#aec1fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.3 209.6-.1 31.2 12.1-20.9v-31.2z",
    fill: "#acc0fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.3 209.6-.1 31.2 12.1-20.9v-31.2z",
    fill: "#6c8ff9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.3 183.8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__X)",
    xlinkHref: "#home-devops-landscape_svg__K"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7784cb",
    xlinkHref: "#home-devops-landscape_svg__K"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m316 253.3.1-31.2z",
    fill: "#99b1fb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.4 218.4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__Y)",
    xlinkHref: "#home-devops-landscape_svg__L"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__Z)",
    xlinkHref: "#home-devops-landscape_svg__L"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m380.9 274.2.2 1.2.1-31.2-.2-1.2z",
    fill: "#527bf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7 5a26.7 26.7 0 0 0-2.9 3 19.2 19.2 0 0 0-3 5.4 16 16 0 0 0-1.1 5.2L.6 50a16.6 16.6 0 0 1 1-5.2L3 42a21.4 21.4 0 0 1 1.8-2.8 26 26 0 0 1 3-3 35.7 35.7 0 0 1 5.8-4.4V.7A35.7 35.7 0 0 0 7.7 5z",
    fill: "url(#home-devops-landscape_svg__N)",
    transform: "translate(288.4 227.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.6 36.8h8V-2.8h-8z",
    fill: "#6287f9",
    mask: "url(#home-devops-landscape_svg__aa)",
    transform: "translate(287.6 244.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.1 275.4.7 29.3.2-31.2-.8-29.3z",
    fill: "#527bf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 .8a170 170 0 0 0-25.2 3.6L.7 25.3l31.8 12.5a73 73 0 0 1 51.7 5.5c7.2 4.1 11.9 9.6 13.2 15.4l-.2 31.4 62-.6v-.3l-.8-30.2v-1a53.5 53.5 0 0 0-.6-3.5c-3.2-14.2-14.4-26.6-30.7-36A155.2 155.2 0 0 0 51.3.3C47 .3 42.4.4 38 .8z",
    fill: "url(#home-devops-landscape_svg__O)",
    transform: "translate(283.6 184.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.9 304.7 60.9.3v-31.3l-60.9-.2z",
    fill: "#6287f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.8 304.9 23 17.6v-31.3L490 273.6z",
    fill: "#d6b7ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.1 304.6 23.1 17.6.1-31.3-23.1-17.6z",
    fill: "#c592c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8 87.5c16.9 9.7 39 16 62.7 17.5l6.2.4h4.4L128.6 88l-23-17.7h-1l-3.3-.2a64.2 64.2 0 0 1-26.7-7.5c-18-10.4-18.2-27.2-.3-37.6L31.1.2c-41.6 24.1-41.3 63.2.7 87.3z",
    fill: "url(#home-devops-landscape_svg__ab)",
    transform: "translate(228 202.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.3 183.8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__Q)",
    xlinkHref: "#home-devops-landscape_svg__ac"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#c885c9",
    xlinkHref: "#home-devops-landscape_svg__ac"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.3 245.4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__S)",
    xlinkHref: "#home-devops-landscape_svg__ad"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__T)",
    xlinkHref: "#home-devops-landscape_svg__ad"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.3 183.8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__ae)",
    xlinkHref: "#home-devops-landscape_svg__V"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#eccae7",
    xlinkHref: "#home-devops-landscape_svg__V"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.3 183.8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__af)",
    xlinkHref: "#home-devops-landscape_svg__ag"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__ah)",
    xlinkHref: "#home-devops-landscape_svg__ag"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m383 339.8 59.8.2v-31.2l-59.7-.2zm59.8.2h1v-31.2h-1z",
    fill: "#a5bafb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118 89.5 23 17.6-23.4 17.5 38.3.2 59.7.2h1l33.3.2 23.4-17.5-23.1-17.6-34.6-.1-61-.3-35.2-.2z",
    fill: "url(#home-devops-landscape_svg__ai)",
    transform: "translate(227.3 183.8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.3 183.8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__aj)",
    xlinkHref: "#home-devops-landscape_svg__ak"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__al)",
    xlinkHref: "#home-devops-landscape_svg__ak"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m443.8 341.3.3 13.5v-31.3L444 310z",
    fill: "#527bf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.2 323.5-.1 31.3.2-31.3z",
    fill: "#6287f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.2 323.5 444 310z",
    fill: "#6f91f9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(489.2 308.1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__am)",
    xlinkHref: "#home-devops-landscape_svg__an"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__ao)",
    xlinkHref: "#home-devops-landscape_svg__an"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M516.8 357.2v31.3l.7-.3.1-31.3z",
    fill: "#688cf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.8 5.2h8v-8.8h-8z",
    fill: "#5980f8",
    mask: "url(#home-devops-landscape_svg__ap)",
    transform: "translate(595.6 335.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.5 11.3h8.6v-14h-8.6z",
    fill: "#5980f8",
    mask: "url(#home-devops-landscape_svg__aq)",
    transform: "translate(595.6 335.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.6 11H7V-3h-9.6z",
    fill: "#5c83f8",
    mask: "url(#home-devops-landscape_svg__ar)",
    transform: "translate(594 341.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.9 10.7H6.9v-14H-4z",
    fill: "#5e84f8",
    mask: "url(#home-devops-landscape_svg__as)",
    transform: "translate(592.4 347.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.5 10.7H8.9V-3.5H-3.4z",
    fill: "#5e84f8",
    mask: "url(#home-devops-landscape_svg__at)",
    transform: "translate(587.6 354.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.8 11.5h14.6v-15H-3.8z",
    fill: "#6086f9",
    mask: "url(#home-devops-landscape_svg__au)",
    transform: "translate(581.3 360.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7 18 .2 35.4h4l3.2.2c10 .7 19.3 3.3 26.6 7.5 18 10.4 18.2 27.2.3 37.6l-3.8 2-2.9 1.3.8-.2-9.2 21.5 33 11.2c5.2-1.7 10.3-3.6 15.1-5.7a114.5 114.5 0 0 0 10.3-5.2c41.5-24.2 41.2-63.2-.7-87.3A148 148 0 0 0 14.2.7L8 .4H.7l23 17.6z",
    fill: "url(#home-devops-landscape_svg__av)",
    transform: "translate(489.2 273.2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.6 335.1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__aw)",
    xlinkHref: "#home-devops-landscape_svg__ax"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__ay)",
    xlinkHref: "#home-devops-landscape_svg__ax"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.5 14.4.4 15.7v1.1l.7 3.5C4.7 49 16 61.3 32.3 70.7c22.6 13 55 20 89.1 17.6a168.1 168.1 0 0 0 35.8-6.4l1.3-.4-33-11.2 9.3-21.5-.8.3-3.5 1.1c-18 6-40.6 4.1-55.6-4.5-7.2-4.1-11.8-9.5-13-15.3l-.3-1.2-.3-13.8L61 1.8V.6h-1L.1.4z",
    fill: "url(#home-devops-landscape_svg__az)",
    transform: "translate(382.9 308.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1.5S3.5-.3 2.5.9c-1 1.2-2.4 4-2.4 6s1.5 1.8 2.4 1.3c1-.4 3.7-4.4 3.9-5.2.1-.7-.2-1.8-.5-2L5 .5",
    fill: "#5793ce",
    mask: "url(#home-devops-landscape_svg__aA)",
    transform: "translate(260.8 311.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.3 311.4v1.6c0 .4-.1.7-.4 1-.3 0-.7.2-1.2.1-1.3-.2-1.4-.5-1.5-2.2 0-1.7 3-.5 3-.5",
    fill: "#d4ecff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4 308.3s-1.6-.8-2.6.4c-1 1.2-2.4 4-2.4 6s1.5 1.8 2.4 1.4 3.7-4.5 3.8-5.2c.2-.8-.2-1.9-.4-2l-.8-.6",
    fill: "#5793ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.8 308v1.6c0 .3-.1.7-.4.9-.3.1-.7.3-1.3.2-1.2-.2-1.3-.6-1.4-2.3 0-1.6 3-.5 3-.5",
    fill: "#d4ecff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.7 277.4c-.4-7.8-8.3 1.1-8.3 1.1l-5.4 5.3-4.6 5.2a4.9 4.9 0 0 0-1.2 3.9l2 15.1c.1.8.7 1.3 1.5 1.3h.7c1.8-.3 1.6-2 1.6-2l-.3-14.1 9.9-6s4.6-2 4.1-9.8",
    fill: "#173d7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.6 280.3c-.5-7.8-8.4 1.2-8.4 1.2l-5.4 5.3-4.8 5.4a4.9 4.9 0 0 0-1.2 3.9l2 15.1c0 .7.7 1.3 1.4 1.3h.7c1.8-.4 1.7-2 1.7-2l-.4-14.2 10.2-6.2s4.7-2 4.2-9.8",
    fill: "#173d7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 255.3c6 2.5 5.8 6 5.8 6s-1.2 13.2-.8 21.9c.2 3.6-19.2 4-16.3-5.8 3.4-11.5 2.1-19.1 3.7-20.5s6-2.2 7.5-1.6",
    fill: "#df55be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.9 258.5c-.3 1.2-2 1.8-3.6 1.4-1.6-.4-2.7-1.8-2.4-3 .3-1.2 1.9-1.9 3.5-1.4 1.7.4 2.8 1.7 2.5 3",
    fill: "#ffc2b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.4 255.6-1.1.2c-.6.3-1 .7-1.1 1.2-.2.5 0 1 .4 1.5a3.4 3.4 0 0 0 1.8 1.1c1.5.4 3-.1 3.2-1.2s-.7-2.3-2.2-2.6a3.8 3.8 0 0 0-1-.2m1 4.7a4.3 4.3 0 0 1-3.3-1.4 2.3 2.3 0 0 1-.5-2 2.3 2.3 0 0 1 1.5-1.6 4 4 0 0 1 2.4-.1c1.8.5 3 2 2.6 3.3-.2 1.1-1.4 1.8-2.8 1.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.5 255v2.2c0 .6 2 1.2 2.6.6.5-.5.3-1.1.4-3.2s-3 .4-3 .4",
    fill: "#ffc2b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5 254.7s-.5 1.9-3 2.6v-1.7l3-1z",
    fill: "#ea9c92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.1 249.8a4.6 4.6 0 1 1-8.9 2.4 4.6 4.6 0 1 1 9-2.4",
    fill: "#ffc2b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.7 250.3s-2.5 1.1-4.3 1.1c-1.7 0-1.3-1.5-1.3-1.5l5.2-.7z",
    fill: "#ea9c92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8 6.3s2.2-1.4 4.1-1c.5.1.9 1.6 1.2 2l.3.2c.4.1 1-1.3 1.6-1.4.7 0 1.1.5.6 1.4-.6.9-.4 1.9-.1 2 .2.1 3.3-2 1-6.8C9-2 2.7.7 1.7 1.7A3.8 3.8 0 0 0 .1 6c.4 1 1.2.8 2.5.3",
    fill: "#396caa",
    mask: "url(#home-devops-landscape_svg__aB)",
    transform: "translate(267.2 244.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.4 271v3.5c0 .4-.1.8-.4 1l-7.2 6.7.8 1.2 10-6.5c.4-.4.6-.9.7-1.4l.7-6.6z",
    fill: "#ffc2b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5.4s2.2 3.3 3 12c0 0-3.7 1.2-5.8.5S3.6.4 3.6.4",
    fill: "#df55be",
    mask: "url(#home-devops-landscape_svg__aC)",
    transform: "translate(277.8 259.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 263.8s-.8 4.6-.8 6.8c0 .6.3 1.1.9 1.3z",
    fill: "#97257c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.2 286.8-1.6-.3-10.3-6a2 2 0 0 0-1.3.1l-7.2 4.2h-1v.9c0 .1 0 .2.2.3l11.7 6.8c.3.2.9.2 1.2 0l8-4.7c.2 0 .3-.3.3-.4z",
    fill: "#5793ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.5 283-.8-.5h-8l-4 2.3h-1v.9l.3.3 11.6 6.8.7.1z",
    fill: "#396caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2 284.8h-.4v.9c0 .1 0 .2.2.3l.2.1zm11.6 8c.3.2.7.1 1 0V291h-1z",
    fill: "#5793ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.6 291.8-11.6-6.7c-.3-.2-.3-.6.1-.8l8-4.6c.3-.2.9-.2 1.2 0l11.7 6.7c.3.2.2.5-.1.8l-8 4.6c-.3.2-1 .2-1.3 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.5 290.8-9.7-5.6c-.3-.2-.3-.5 0-.6l4.3-2.5c.3-.1.8-.2 1 0l9.7 5.6c.3.2.3.5 0 .6l-4.3 2.5c-.3.1-.8.2-1 0",
    fill: "#d4ecff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.5 279.5-.1.8a6 6 0 0 0 0 2l.2.8c0 .4.4.7.8.8.3 0 .6-.2.6-.5l.2-1.7s.4.5.6.5-.2-1.7-.7-2.7-1.6 0-1.6 0",
    fill: "#ffc2b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.4 266.6-1.2 2.5c-.3.6-.5 1.2-.5 1.9l-.6 8.5h-1.6l-.8-9.6v-.9l1-4.9z",
    fill: "#ffc2b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.3 292.5-1-1.3-10.3-6c-.3-.2-.6-.7-.6-1.1v-8.5l-.6-.8.6-.3h.4l11.6 6.8c.4.2.6.7.6 1.1v9.3c0 .2 0 .4-.2.5z",
    fill: "#173d7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.2 287.6-.8-.4-4-7v-4.6l-.6-.8.6-.3h.4l11.6 6.8.5.5z",
    fill: "#396caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.1 275.1-.3-.3.6-.3h.4l.2.1z",
    fill: "#5793ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 281.4c.3.2.5.6.5 1l-1.1.6-.6-1z",
    fill: "#274f89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.9 281.6-11.7-6.8c-.3-.2-.6 0-.6.5v9.2c0 .5.3 1 .6 1.2l11.7 6.8c.3.1.6 0 .6-.5v-9.2c0-.5-.3-1-.6-1.2",
    fill: "#5793ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.6 283.4-.2.4a2.6 2.6 0 0 1-1 1l-1.1.8c-.4.2-.8.2-1.2 0-.4-.2-.4-.8-.1-1l1.2-1.3s-.7.5-.9.3c-.1-.2.7-1 1.3-1 .6 0 1.2-.4 1.2-.4z",
    fill: "#ffc2b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 256.4s-4.9 3.6-6.7 8a9 9 0 0 0 5.2 4c3.8 1 1.5-12 1.5-12",
    fill: "#df55be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.7 268 .7-7-1.7 6.6 1 .4",
    fill: "#97257c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.9 254.2-1.2-.3s.5.9 1.4 1 1-.4 1-.4l-1.3-.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363 375.7v8c-.3 1-1.4 2-3.3 3L314.5 413c-3.4 2-8.4 2.1-11.3.5l-46.8-27.3c-1.4-.8-2.2-1.5-2.4-3a43 43 0 0 1 0-7.5h36.7l11.7-6.8c3.4-2 8.4-2.2 11.3-.5l12.5 7.3z",
    fill: "hsla(0,0,100%, 1)",
    stroke: "#afabde"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.2 406.8-47.4-27.6c-2.9-1.7-2.5-4.7.9-6.7l45.7-26.6c3.3-2 8.4-2.2 11.3-.5l47.4 27.6c2.9 1.7 2.5 4.7-.8 6.6l-45.8 26.7c-3.3 2-8.4 2.2-11.3.5",
    fill: "currentColor",
    stroke: "#a8a3e8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.6 382.3c.2 0 .2.2.1.3l-10.1 12.6c-.2.2-.4.2-.7.2l-2.6-.6-14.8-8.8 5.9-7.7c0-.1.4-.2.6-.1l21.5 4zm-.2-5.8c.1 0 .2.2 0 .4L330 380l-20.5-3.9c-.3 0-.5 0-.6.2l-6.4 8.3-6-3.6 7.5-9.7c.1-.2.5-.3.8-.2l27.5 5.2h.2zm-1.5-6.3c.2.2.3.3.2.5l-2.8 3.3-25.3-4.7a1 1 0 0 0-.8.1l-8 10.5-5.7-3.4 9.4-12.2c.2-.2.6-.3.9-.2l31.9 6a.8.8 0 0 1 .2.1zm-35.5-6.7v.1l-9 11.6-8.5-5.1-.1-.2 3.9-4.7v-.1l13.4-1.7h.3z",
    fill: "#7362c0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183 44)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__aD)",
    xlinkHref: "#home-devops-landscape_svg__aE"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__aF)",
    xlinkHref: "#home-devops-landscape_svg__aE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 2.3S5.5 5.6 6.3 6c1.1.8.4 1.5-.1 1.5S3 7.7 2.4 7c-.6-.6-.9-2.6-1.4-3-.6-.7-1.2-2.8.2-3.3C2.5.2 3.6 2.3 3.6 2.3",
    fill: "#eea1e6",
    mask: "url(#home-devops-landscape_svg__aG)",
    transform: "translate(565.8 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m568.5 406.9 2.6 4.4c.4.6-.7.6-1.4.3s-2.4-3-2.6-3.6c-.3-.6 0-1.3 0-1.3l1.4.1z",
    fill: "#5b4997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m566.3 409 .5 4h.3l-.1-3z",
    fill: "#eea1e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2 1.6S5.2 5 6 5.5c1 .7.4 1.5-.1 1.5-.6 0-3.3.2-3.8-.5-.6-.7-1-2.7-1.5-3.3C.1 2.7-.5.5 1 .1c1.2-.4 2.3 1.5 2.3 1.5",
    fill: "#eea1e6",
    mask: "url(#home-devops-landscape_svg__aH)",
    transform: "translate(547 406.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549.5 406.9 2.5 4.4c.4.6-.7.6-1.4.3s-2.4-3-2.7-3.6c-.3-.6 0-1.3 0-1.3z",
    fill: "#5b4997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m547.1 409 .5 4h.3v-3z",
    fill: "#eea1e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.6 378.1 17.5 8s2 .7 2.2 3c.7 6.8 5.7 17.6 5.7 17.6 1.6.8 1.5.1 1.5.1a202 202 0 0 1-2.9-24.7c0-.2-.2-.4-.5-.7-2.4-2-12.2-6-12.2-6-7.4-.2-11.3 2.7-11.3 2.7",
    fill: "#6551a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.4 381.6c.5 4.8 7.2 4.2 7.2 4.2h8.2s-2.1 4.9-3 9c-.9 4.3-3 12-3 12s.2.2 1.7 0c0 0 6.4-12.9 8.9-16.2.5-.7 2-4.5 2.3-6.7 0-.8 0-1.4-.3-1.6l-1.8-1.3a44 44 0 0 0-9.5-4.7l-8.5-2.2s-2.8 2.7-2.3 7.5",
    fill: "#6551a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3 9.2S.1 7 .7 4.4 3.6-.6 7 .5c3.3 1.1 6 3.8 4 6.8-2 3.1 1.8 4.5.8 6-1 1.4-.6 3-.2 3.2.5.4 1.8 1.6 1.7 3-.2 1.5-6.6-4.1-6.6-4.1S3.3 8.3 1.3 9.2",
    fill: "#692bb5",
    mask: "url(#home-devops-landscape_svg__aI)",
    transform: "translate(542.6 335.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.1 374.8s-.5 2.5-13.5-.7c0 0 4.4-1.4 13.6.7",
    fill: "#eb4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.4 374.8-.6 1.2 14.4.4c-.8-2.5-.6-6-.4-8.6.1-3.3 1.9-5.5 1.7-8.7l2 .3c-1.4-4.2-1.9-6.2-6.4-7.9a8.3 8.3 0 0 0-4-.5c-5.2.5-6.8.5-9.3 5.3 4 .7 3.3 2.1 4.5 6.1a17 17 0 0 1 1 6.3c-.4 2-2.9 4.3-2.9 6.1",
    fill: "#9e77df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.7 352.6c-2-.5-1.6-1.7-1.6-1.7l.1-1.5a14.2 14.2 0 0 0 0-1.7c-.2-1.5 3.8-.6 3.8-.6s-.2 3 .4 3.8c.5.9-.5 2-2.6 1.7",
    fill: "#f9beaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.7 351s4.3 5 5.9 6.1c0 0 1.8-1.6.7-6 0 0-2.1-1.1-6.6-.2",
    fill: "#f9beaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.8 338.9s-2.2 4.3 0 8.4c2.2 4.2 6.5-1.8 6.8-2.5.3-.7 1.8-4.6-1.2-5.8-3-1.2-5-1.3-5.6-.1",
    fill: "#ffcabd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.5 340.4s-1.5 2-1.7 3.5c0 0-.6-2.8 1.1-5.5s6.2-.2 6.7 1 2.4 2-.5 6.7c0 0-5.2-3.7-5.6-5.7",
    fill: "#692bb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.1 347.8s-.4.8-1.9 1.6v-.7s1 0 2-1",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.6 371s-1 .4-1.6.2a4.6 4.6 0 0 0-1.5-.3c-.3 0-1.4-.4-1.4 0 0 .5 1.7.7 2 .9.4 0-1 .8-1 1.2-.2.3 1.3 2.5 2.2 1.9.8-.6 1.3-1.9 1.5-2l.6-.4z",
    fill: "#ffccbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.2 372.8s-2.5 2-2.6 2.3c0 .3.1.5.4.3l2.5-2-2.6 3.2c0 .2.2.4.3.3a135 135 0 0 0 2.8-2.8s-2.3 2.7-2.3 3c0 .1.2.3.4.1l2.5-2.6s-1.5 2.1-1.5 2.3c.1.1.3.4.7-.2l1.4-1.8z",
    fill: "#ffccbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 385.8h-7.4s-6.7.6-7.3-4.2c-.5-4.8 2.3-7.5 2.3-7.5l6.6 1.8a23.8 23.8 0 0 1 5.7-.5s13.2 4.4 12.8 6.7c0 0-5.6-3-12.7 3.7",
    fill: "#5e5fcb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520.6 335)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#c5d4ff",
    xlinkHref: "#home-devops-landscape_svg__aJ"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__aK)",
    fillOpacity: 0.2,
    xlinkHref: "#home-devops-landscape_svg__aJ"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M552.5 375.7s-3.1 1.3-7 .1l-.1-1.4 7.9.4-.8 1z",
    fill: "#325bb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m555.1 381-7-2.8v-.7l7.5 2.7z",
    fill: "#708fc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.5 376.4a.7.7 0 0 0 1 .7l.7-.4c.3 0 .4-.3.4-.6-.3-2.1-1-10.5 0-11.9l.8-1.4 1.9 5.5 6.6 8.8 2.2.6c-2.8-6.7-5-10.3-5-10.3l-2.8-7.9-1.6-4.8c-.2-.5-.5-1-1-1.2a60.5 60.5 0 0 0-4.3-2.4h-.1c2.9 4.4 1.8 17.1 1.2 25.3zm-11-25c-.9.2-3.2 2.5-4.4 4.8-1.4 2.6-2.9 5.6-4 6.6-2 1.8-7.5 8.3-7.7 8.1-.1 0 1.5 2 1.7 2 0 0 9.1-7.8 10-9 .8-1.2 3-6 3.6-5.9a36 36 0 0 1 1.7 4.6 14.6 14.6 0 0 1-2 11.5v.7l.3.3 2.6 1 .7.2a1.4 1.4 0 0 0 1.8-1 85 85 0 0 1 1.9-11.1 17 17 0 0 0-1-13.6s-4.3.5-5.1.8",
    fill: "#ffc8ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m555.5 379.7 3.5-9.7a.9.9 0 0 1 .9-.5l11.5.2a.9.9 0 0 1 .8 1.2l-3.3 8.8a.9.9 0 0 1-.8.6l-11.7.6a.9.9 0 0 1-.8-1.2z",
    fill: "#a2b5ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.4 343.2s.9 1.3 0 2.5c-.7 1.2.3 2.3.5 3.5s-3.3 4.6.5 6.2c3.9 1.7 5.1-1 4.1-2.6a8.6 8.6 0 0 1-1.7-4.8c-.1-2.2-.8-5.5-3.4-4.8",
    fill: "#692bb5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6d6fd0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M648 461.2v8.7c0 .1 0 .4.3.5.4.3 1 .3 1.4 0 .2-.1.3-.3.3-.5v-8.7c0-.6-.5-1-1-1a1 1 0 0 0-1 1zm-4-2.3v9.6c0 .2.1.5.3.6.4.4 1 .4 1.5 0 .2-.1.3-.4.3-.6V459c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-3.9-2.2v9.5c0 .3.1.5.3.7.4.3 1 .3 1.4 0 .2-.2.3-.4.3-.7v-9.5c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-4-2.3v9.6c0 .2.2.4.4.6.4.3 1 .3 1.4 0l.3-.6v-9.6c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-3.8-2.3v9.6c0 .2 0 .4.3.6.4.4 1 .4 1.4 0l.3-.6V452c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-4-2.3v9.6c0 .2.1.5.3.6.4.4 1 .4 1.5 0 .2-.1.3-.4.3-.6V450c0-.6-.5-1-1-1a1 1 0 0 0-1 1zm-3.9-2.2v9.5c0 .3.1.5.3.7.4.3 1 .3 1.4 0l.3-.6v-9.6c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-4-2.3v9.6c0 .2.2.4.4.6.4.3 1 .3 1.4 0l.3-.6v-9.6c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-3.9-2.3v9.6l.3.6c.4.4 1 .4 1.5 0 .2-.1.3-.4.3-.6V443c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-3.9-2.3v9.6c0 .2.1.5.3.6.4.4 1 .4 1.5 0 .2-.1.3-.3.3-.6v-9.5c0-.6-.5-1-1-1a1 1 0 0 0-1 1zm-4-.6v6.7c0 .2.2.4.4.5.4.4 1 .4 1.4 0 .2-.1.3-.3.3-.5V440c0-.5-.4-1-1-1a1 1 0 0 0-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 438.2v9.6c0 .2 0 .4.3.6.4.3 1 .3 1.4 0l.3-.6v-9.6c0-.6-.5-1-1-1a1 1 0 0 0-1 1zm-4-2.3v9.6c0 .2.1.5.3.6.4.4 1 .4 1.5 0 .2-.1.3-.4.3-.6V436c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-3.9-2.2v9.5c0 .3.1.5.3.7.4.3 1 .3 1.4 0 .2-.2.3-.4.3-.7v-9.5c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-4-2.3v9.6c0 .2.2.4.4.6.4.3 1 .3 1.4 0l.3-.6v-9.6c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-3.8-2.3v9.6c0 .2 0 .4.3.6.4.4 1 .4 1.4 0l.3-.6V429c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-4-2.3v9.6c0 .2.1.5.3.6.4.4 1 .4 1.5 0 .2-.1.3-.4.3-.6V427c0-.6-.5-1-1-1a1 1 0 0 0-1 1zm-3.9-2.2v9.5c0 .3.1.5.3.7.4.3 1 .3 1.4 0l.3-.6v-9.6c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-4-2.3v9.6c0 .2.2.4.4.6.4.3 1 .3 1.4 0l.3-.6v-9.6c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-3.9-2.3v9.6l.3.6c.4.4 1 .4 1.5 0 .2-.1.3-.4.3-.6V420c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm99.5 25.2v8.6c0 .2.2.4.4.6.4.3 1 .3 1.4 0l.3-.6v-8.6c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-3.8-2.3v8.6c0 .3 0 .5.3.6.4.3 1 .3 1.4 0 .2-.1.3-.3.3-.5v-8.7c0-.6-.5-1-1-1a1 1 0 0 0-1 1zm-4-2.3v8.7l.3.6c.4.3 1 .3 1.5 0l.3-.6v-8.7c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-3.9-2.2v8.6l.3.6c.4.3 1 .3 1.4 0 .3-.2.4-.4.4-.6v-8.6c0-.6-.5-1-1-1a1 1 0 0 0-1 1zm-4-2.3v8.6c0 .2.2.4.4.6.4.3 1 .3 1.4 0 .2-.1.3-.4.3-.6v-8.6c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-3.8-2.3v8.7c0 .2 0 .4.3.5.4.3 1 .3 1.4 0 .2-.1.3-.3.3-.5v-8.7c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-4-2.3v8.7l.3.6c.4.3 1 .3 1.5 0l.3-.6v-8.7c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-3.9-2.2v8.6l.3.6c.4.3 1 .3 1.4 0l.3-.6v-8.6c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-4-2.3v8.6c0 .2.2.5.4.6.4.3 1 .3 1.4 0 .2-.1.3-.3.3-.6V427c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-3.8-2.3v8.7c0 .2 0 .4.3.5.4.4 1 .4 1.4 0 .2-.1.3-.3.3-.5v-8.7c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-4-.6v6.6c0 .2.1.5.3.6.4.3 1 .3 1.5 0 .2-.1.3-.3.3-.5V424c0-.6-.5-1-1-1a1 1 0 0 0-1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m557.4 426.6 54.3-37.9a8.3 8.3 0 0 0 3.4 10.8l72.2 40.9-38.4 23.7-61.3-34.7a37 37 0 0 0-30.1-2.8z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 462.1v.8h2v-.8c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-4-2.2v.7h.3c.4.2 1 .2 1.5 0h.3v-.7a1 1 0 1 0-2 0zm-3.9-2.3v.7l.3.1h1.7v-.8a1 1 0 1 0-2 0zm-4-2.3v.7l.4.1h1.7v-.8a1 1 0 1 0-2 0zm-3.8-2.2v.7h2v-.7a1 1 0 1 0-2 0zm-4-2.3v.7h.3c.4.2 1 .2 1.5 0h.3v-.7a1 1 0 1 0-2 0zm-3.9-2.3v.7l.3.1h1.7v-.8a1 1 0 1 0-2 0zm-4-2.3v.8h2.2v-.8a1 1 0 1 0-2 0zm-3.9-2.2v.7h2.1v-.7a1 1 0 1 0-2 0zm-3.9-2.3v.7l.3.1h1.5l.3-.1v-.7a1 1 0 1 0-2 0zm-3.6-2.3v.7l.3.1h1.4l.3-.1v-.7a1 1 0 1 0-2 0zm-4-2.1v.7h.3c.4.2 1 .2 1.5 0h.3v-.7a1 1 0 1 0-2 0zm-3.9-2.3v.7l.3.1h1.7v-.8a1 1 0 1 0-2 0zm-4-2.3v.7l.4.1h1.7v-.8a1 1 0 1 0-2 0zm-3.8-2.2v.7h2v-.7a1 1 0 1 0-2 0zm-4-2.3v.7h.3c.4.2 1 .2 1.5 0h.3v-.7a1 1 0 1 0-2 0zm-3.9-2.3v.7l.3.1h1.7v-.8a1 1 0 1 0-2 0zm-4-2.3v.8h2.2v-.8a1 1 0 1 0-2 0zm-3.9-2.2v.7h2.1v-.7a1 1 0 1 0-2 0zm54.5-8.8v.8h2v-.8a1 1 0 1 0-2 0zm-4-2.2v.7h.3c.4.2 1 .2 1.4 0h.3v-.7a1 1 0 1 0-2 0zm-4-2.3v.7l.4.1h1.7v-.8a1 1 0 1 0-2 0zm-3.8-2.3v.7l.3.1h1.7v-.8a1 1 0 1 0-2 0zm-4-2.2v.7h2.1v-.7a1 1 0 1 0-2 0zm-3.9-2.3v.7h.3c.4.2 1 .2 1.4 0h.3v-.7a1 1 0 1 0-2 0zm-4.2-2.3v.7l.3.1h1.7v-.8a1 1 0 1 0-2 0zm-4.2-2.3v.8h2.1v-.8a1 1 0 1 0-2 0zm71.6 40.9v.7h.3c.4.2 1 .2 1.4 0h.3v-.7a1 1 0 1 0-2 0zm-4-2.3v.7l.4.1h1.7v-.8a1 1 0 1 0-2 0zm-3.9-2.3v.7l.3.1h1.8v-.8c0-.5-.5-1-1-1a1 1 0 0 0-1 1zm-3.9-2.2v.7h2.1v-.7a1 1 0 1 0-2 0zm-4-2.3v.7h.4c.4.2 1 .2 1.4 0h.3v-.7a1 1 0 1 0-2 0zm-3.8-2.3v.7l.3.1h1.7v-.8c0-.6-.5-1-1-1a1 1 0 0 0-1 1zm-4-2.3v.8h2.1v-.8a1 1 0 1 0-2 0zm-3.9-2.2v.7h2v-.7a1 1 0 1 0-2 0zm-4-2.3v.7l.4.1h1.4l.3-.1v-.7c0-.6-.4-1-1-1a1 1 0 0 0-1 1zm-3.8-2.3v.7l.3.1h1.7v-.8a1 1 0 1 0-2 0zm-4.2-2.2v.7l.3.1h1.8v-.8a1 1 0 1 0-2 0z",
    fill: "#6d6fd0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.7 470.4v9.7c-.5 1.5-2 2.9-4.5 4.1L689.8 531c-4.6 2.7-11.5 3-15.4.7L609.8 494c-1.9-1-3-2-3.3-4.2-.2-1.4-.2-4.4 0-9l71.7-10.6 16-9.3c4.7-2.7 11.6-3 15.5-.7l17.3 10z",
    fill: "#aab0e4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 487.7c-4-2.3-3.5-6.4 1.2-9l84-48.2c4.6-2.7 11.6-3 15.6-.6l65.2 38c4 2.3 3.5 6.4-1.1 9.1l-84 48.1c-4.6 2.7-11.6 3-15.6.7l-65.2-38z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4.4V7l-.3.4c-.4.2-1 .2-1.3 0C.6 7.3.5 7 .5 7V.4h1.9z",
    mask: "url(#home-devops-landscape_svg__aL)",
    transform: "matrix(-1 0 0 1 758.9 525.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4.1v6.6l-.3.4c-.4.2-1 .2-1.4 0l-.2-.4V.1z",
    mask: "url(#home-devops-landscape_svg__aM)",
    transform: "matrix(-1 0 0 1 755.2 523.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4.5V7c0 .2-.1.3-.3.4-.4.2-1 .2-1.4 0L.5 7V.5h1.9z",
    mask: "url(#home-devops-landscape_svg__aN)",
    transform: "matrix(-1 0 0 1 751.5 521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3.2v6.6l-.2.4c-.4.2-1 .2-1.4 0l-.3-.4V.2z",
    mask: "url(#home-devops-landscape_svg__aO)",
    transform: "matrix(-1 0 0 1 747.9 519.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3.5v6.6c0 .2 0 .3-.2.4-.4.2-1 .2-1.4 0-.2-.1-.3-.2-.3-.4V.5h2z",
    mask: "url(#home-devops-landscape_svg__aP)",
    transform: "matrix(-1 0 0 1 744.2 516.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3.3v6.5c0 .2 0 .3-.3.4-.3.2-1 .2-1.3 0-.2-.1-.3-.2-.3-.4V.3h2z",
    mask: "url(#home-devops-landscape_svg__aQ)",
    transform: "matrix(-1 0 0 1 740.5 515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3.6v6.5c0 .2-.1.3-.3.4-.4.3-1 .3-1.3 0-.2 0-.3-.2-.3-.3V.6z",
    mask: "url(#home-devops-landscape_svg__aR)",
    transform: "matrix(-1 0 0 1 736.8 512.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3.3V7l-.3.4c-.4.2-1 .2-1.3 0C.5 7.3.4 7.1.4 7V.3h1.9z",
    mask: "url(#home-devops-landscape_svg__aS)",
    transform: "matrix(-1 0 0 1 733.2 510.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3 0v6.6L2 7c-.4.2-1 .2-1.4 0l-.2-.4V.1h1.9z",
    mask: "url(#home-devops-landscape_svg__aT)",
    transform: "matrix(-1 0 0 1 729.5 508.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 478.2h-4.4v-12.8h4.3z",
    fill: "#d59ad8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.6 478c0 .8 1 1.3 2.2 1.3s2.2-.6 2.2-1.3c0-.6-1-1.2-2.2-1.2s-2.2.6-2.2 1.3",
    fill: "#cd90d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.6 465.4c0 .7 1 1.2 2.2 1.2s2.2-.5 2.2-1.2-1-1.3-2.2-1.3-2.2.6-2.2 1.3",
    fill: "#d073ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 468v-7.6c0-.7-1-1.2-2.2-1.2s-2.2.5-2.2 1.2v7.7c.1.6 1 1 2.2 1 1.1 0 2-.4 2.1-1v-.2z",
    fill: "#d59ad8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 63V20h.4a12.3 12.3 0 0 0 .4 0h.4a9.2 9.2 0 0 0 4-1L34 2.5C35 2 35.6 1 35.6.2v43c0 .8-.5 1.6-1.4 2.2l-.3.2-2.9 1.6-25.7 15c-1.1.6-2.6.9-4.1.9H0z",
    fill: "url(#home-devops-landscape_svg__aU)",
    transform: "matrix(-1 0 0 1 682.6 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7 17.6 30.3 1a9 9 0 0 1 8.2 0l51.8 30c1.1.6 1.7 1.5 1.7 2.4 0 .8-.6 1.7-1.7 2.3L61.7 52.2a8.2 8.2 0 0 1-4.1 1h-1.1a7.8 7.8 0 0 1-3-1L1.7 22.3C.6 21.7 0 20.8 0 19.9c0-.9.6-1.7 1.7-2.3",
    fill: "url(#home-devops-landscape_svg__aV)",
    transform: "matrix(-1 0 0 1 739 414.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 27.9c0 .8.5 1.7 1.7 2.4l11 6.1-.1 15.3 41 23.7c.8.5 1.8.8 2.9.9v-43a7.8 7.8 0 0 1-3-1L1.7 2.3C.6 1.8 0 1 0 0z",
    fill: "#d3b2fe",
    mask: "url(#home-devops-landscape_svg__aW)",
    transform: "matrix(-1 0 0 1 739 434.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m719.5 462 3.7-2.2v3.3l-3.7 2.1zm0-7v-3.2l3.7-2.2v3.2zm-1.8 1-3.8 2.3V455l3.8-2.2v2.6zm-3.8 12.5v-3.3l3.8-2.2v3.3zm-5.5-10.3 3.8-2.2v3.3l-3.8 2.2zm3.8 11.3-3.8 2.2v-3.3l3.8-2.1zm-5.6 3.2L703 475v-3.2l3.7-2.2v2.5zm0-10.2-3.7 2.2v-3.2l3.7-2.2v1.7zm-5.5 13.4-3.7 2.2V475l3.7-2.2v2.6zm0-11.6v1.4l-3.7 2.2v-3.2l3.7-2.2v1zm-5.5 4.7-3.8 2.2v-3.3l3.8-2.2v2.6zm-3.8 12.4V478l3.8-2.2v3.3zm-5.5-10.3 3.8-2.2v3.3l-3.8 2.2zm3.8 11.3-3.8 2.2v-3.3l3.8-2.1zm33.1-9.1-3.7 2.2v-3.3l3.7-2.2zm-9.2 5.4v-3.3l3.7-2.1v3.2zm-5.6 13.4V489l3.8-2.2v3.2zm3.8-12.4-3.8 2.2v-3.2l3.8-2.2v2.5zm-9.3 5.4V482l3.7-2.2v3.2zm-5.5 3.3V485l3.7-2.2v3.3zm0 10.2v-3.3l3.7-2.2v3.3zm-5.6-7v-3.3l3.8-2.2v3.3zm-5.5 13.4v-3.2l3.8-2.2v3.2zm3.8-12.4-3.8 2.2v-3.2l3.8-2.2v2.5zm33.1-12.4v3.3l-3.7 2.2v-3.3zm-5.5 3.3v3.2L714 489v-3.2zm-11 7v2.7l-3.8 2.1v-3.2l3.7-2.2zm-11.1 5.9v3.2l-3.8 2.2v-3.3z",
    fill: "#b2a0cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m733.2 432.8-.7-.5-.3-.1-2.4-1.4-22.3-12.9a6.7 6.7 0 0 0-5.8 0l-22.9 13.2-.4.3-25 14.4-.6.4c-1.4.7-1.8 1.8-1.3 2.7.2.4.5.7 1 1l.3.2h.2l25.5 14.8a5.9 5.9 0 0 0 2.9.7h.6l.3-.1c.7 0 1.5-.3 2-.6l48.8-28.2h.1a4 4 0 0 0 .3-.2c.5-.3.8-.6 1-1 .5-1 0-2-1.3-2.7",
    fill: "#9075be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7 47.7a6 6 0 0 1-3 .6H53c-.8-.1-1.5-.3-2-.6L1.7 19.5l.6-.4.4-.2L5 17.5 27.5 4.7a6.8 6.8 0 0 1 5.8 0l23 13.2.5.2A53673.4 53673.4 0 0 0 82.5 33l-.2.1-25.6 14.7z",
    fill: "url(#home-devops-landscape_svg__aX)",
    transform: "matrix(-1 0 0 1 734.9 417.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.4 3 7 6.8V4.6L.4.8z",
    fill: "#8462bc",
    mask: "url(#home-devops-landscape_svg__aY)",
    transform: "matrix(-1 0 0 1 688.4 454.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 4 18.6.2.4 10.7 7 14.5z",
    fill: "url(#home-devops-landscape_svg__aZ)",
    transform: "matrix(-1 0 0 1 688.4 444.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m681.4 461.4-18.2-10.5v-2.2l18.2 10.5z",
    fill: "#a17fe3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.4 2.4 7 6.2V4L.4.2z",
    fill: "#8462bc",
    mask: "url(#home-devops-landscape_svg__ba)",
    transform: "matrix(-1 0 0 1 700.8 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 4.3 18.6.5.4 11 7 14.8z",
    fill: "url(#home-devops-landscape_svg__aZ)",
    transform: "matrix(-1 0 0 1 700.8 437.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m693.8 454.2-18.2-10.5v-2.2l18.2 10.5z",
    fill: "#a17fe3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.4 2.1 2.2 1.4v-2L.4.2z",
    fill: "#c682b5",
    mask: "url(#home-devops-landscape_svg__bb)",
    transform: "matrix(-1 0 0 1 698.3 439.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 1.9 2.8.5.4 1.9l2.2 1.3z",
    fill: "url(#home-devops-landscape_svg__bc)",
    transform: "matrix(-1 0 0 1 698.3 438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m695.7 443.1-2.4-1.3v-2l2.4 1.4z",
    fill: "#583896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.8 2.4 3 3.8v-2L.8.6z",
    fill: "#c682b5",
    mask: "url(#home-devops-landscape_svg__aK)",
    transform: "matrix(-1 0 0 1 705 435.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4 2.2 3 .8.8 2.2 3 3.5z",
    fill: "url(#home-devops-landscape_svg__bd)",
    transform: "matrix(-1 0 0 1 705 433.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m702 439.3-2.4-1.4V436l2.4 1.4z",
    fill: "#583896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.3 2.7 2.2 1.4V2L.3.9z",
    fill: "#c682b5",
    mask: "url(#home-devops-landscape_svg__be)",
    transform: "matrix(-1 0 0 1 710.8 431.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9 1.6 2.6.3.3 1.6 2.5 3z",
    fill: "url(#home-devops-landscape_svg__bc)",
    transform: "matrix(-1 0 0 1 710.8 430.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m708.3 435.4-2.4-1.3v-2l2.4 1.4z",
    fill: "#583896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4 490v1.5c-1.9 1-2.8 2.2-3.8 3.6a14.4 14.4 0 0 1-4.5 4.2c-2.2 1.3-3.4 1.1-4.5 1-1-.2-2-.3-3.8.8a11.7 11.7 0 0 0-3.8 3.5 14.4 14.4 0 0 1-4.5 4.2c-2.3 1.4-3.4 1.2-4.5 1s-2-.3-3.8.8c-1.9 1-2.8 2.2-3.8 3.6a14.4 14.4 0 0 1-4.5 4.2c-2.3 1.3-3.4 1.1-4.5 1-1-.2-2-.3-3.8.7-1.9 1.1-2.8 2.3-3.8 3.6-1 1.4-2.2 3-4.5 4.2s-3.4 1.2-4.5 1-2-.3-3.8.8v-1.5c2.3-1.3 3.5-1.2 4.5-1s2 .3 3.8-.8a11.8 11.8 0 0 0 3.8-3.6c1-1.3 2.2-2.9 4.5-4.2 2.3-1.3 3.5-1.1 4.5-1 1 .2 2 .4 3.8-.7 1.9-1.1 2.8-2.3 3.8-3.6a14.4 14.4 0 0 1 4.5-4.2c2.3-1.3 3.5-1.1 4.5-1 1 .2 2 .3 3.8-.8 1.9-1 2.8-2.2 3.8-3.5 1-1.4 2.2-3 4.5-4.2s3.5-1.2 4.5-1c1 .1 2 .3 3.8-.8 1.9-1 2.8-2.2 3.8-3.6a14.4 14.4 0 0 1 4.5-4.2m1.3 21.3c-2 1-2.8 2.2-3.8 3.5a14.4 14.4 0 0 1-4.5 4.3c-2.3 1.3-3.5 1-4.5 1-1-.2-2-.4-3.8.7a11.7 11.7 0 0 0-3.8 3.6 14.4 14.4 0 0 1-4.5 4.2c-2.3 1.3-3.5 1.1-4.5 1s-2-.3-3.8.8c-2 1-2.8 2.2-3.8 3.5a14.4 14.4 0 0 1-4.5 4.2c-2.3 1.3-3.5 1.2-4.5 1-1-.2-2-.3-3.8.8-2 1-2.3-.2 0-1.5 2.2-1.3 3.4-1.1 4.5-1 1 .2 1.9.3 3.8-.8 1.8-1 2.7-2.2 3.8-3.5 1-1.4 2.2-3 4.5-4.3 2.2-1.3 3.4-1 4.5-1 1 .2 1.9.4 3.8-.7 1.8-1.1 2.7-2.2 3.8-3.6 1-1.3 2.2-2.9 4.5-4.2 2.2-1.3 3.4-1.1 4.5-1 1 .2 1.9.3 3.8-.7 1.9-1.1 2.7-2.3 3.8-3.6a14.4 14.4 0 0 1 4.5-4.2v1.5zM64.9 503a12 12 0 0 0-3.8 3.5 14.4 14.4 0 0 1-4.5 4.2c-2.3 1.3-3.5 1.1-4.5 1-1-.2-2-.3-3.8.8a11.7 11.7 0 0 0-3.8 3.5 14.4 14.4 0 0 1-4.5 4.3c-2.3 1.3-3.5 1-4.5 1-1-.2-2-.4-3.8.7-2 1-2.8 2.2-3.8 3.6a14.4 14.4 0 0 1-4.5 4.2c-2.3 1.3-3.5 1.1-4.5 1-1-.2-2-.3-3.8.8-2 1-2.8 2.2-3.8 3.5-1 1.4-1.8.5-.7-.8 1-1.4 2.2-3 4.5-4.3 2.2-1.3 3.4-1 4.5-1 1 .2 1.9.4 3.8-.7 1.8-1.1 2.7-2.2 3.8-3.6 1-1.4 2.2-2.9 4.5-4.2 2.2-1.3 3.4-1.1 4.5-1s1.9.3 3.8-.8c1.9-1 2.7-2.2 3.8-3.5 1-1.4 2.2-3 4.5-4.2 2.2-1.3 3.4-1.2 4.5-1 1 .2 1.9.3 3.8-.8 1.8-1 2.7-2.2 3.8-3.6a14.4 14.4 0 0 1 4.5-4.2z",
    fill: "#9cb3e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.3 183 610 212l76 44.3-55.5 32.7",
    stroke: "#91afdf"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 662.5,
    cy: 183.5,
    fill: "#7ca3e2",
    rx: 5.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 362)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#home-devops-landscape_svg__bf)",
    xlinkHref: "#home-devops-landscape_svg__bg"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#home-devops-landscape_svg__bh)",
    xlinkHref: "#home-devops-landscape_svg__bg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 147.5 3.1 1.8 83-48.4-3-1.8z",
    fill: "url(#home-devops-landscape_svg__bi)",
    transform: "translate(27 362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 53 .2 66.2-31.1 24.1z",
    fill: "url(#home-devops-landscape_svg__bj)",
    transform: "translate(27 362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 141.5 3.1 1.8 31-90.3-3.2-1.9z",
    fill: "url(#home-devops-landscape_svg__bk)",
    transform: "translate(27 362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4 116.1 86.1 95l-47-93z",
    fill: "url(#home-devops-landscape_svg__bl)",
    transform: "translate(27 362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 0 .3 114.3 3.1 1.8-.3-114.3L36 0z",
    fill: "url(#home-devops-landscape_svg__bm)",
    transform: "translate(27 362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.4 91v1.5c-2 1-2.8 2.2-3.8 3.5a14.4 14.4 0 0 1-4.5 4.3c-2.3 1.3-3.5 1-4.5 1-1-.2-2-.4-3.8.7a11.8 11.8 0 0 0-3.8 3.6 14.5 14.5 0 0 1-4.5 4.2c-2.3 1.3-3.5 1.2-4.5 1s-2-.3-3.8.8c-1.9 1-2.8 2.2-3.8 3.6a14.4 14.4 0 0 1-4.5 4.2c-2.3 1.3-3.5 1.1-4.5 1-1-.2-2-.3-3.8.8-1.9 1-2.8 2.2-3.8 3.5-1 1.4-2.2 3-4.5 4.3-2.2 1.3-3.4 1-4.5 1-1-.2-2-.4-3.8.7v-1.5c2.3-1.3 3.5-1.1 4.5-1 1 .2 2 .3 3.8-.8a11.8 11.8 0 0 0 3.8-3.5c1-1.4 2.2-3 4.5-4.3 2.3-1.3 3.5-1 4.5-1 1 .2 2 .4 3.8-.7 1.9-1.1 2.8-2.3 3.8-3.6a14.4 14.4 0 0 1 4.5-4.2c2.2-1.3 3.4-1.2 4.5-1s1.9.3 3.8-.8c1.9-1 2.7-2.2 3.8-3.6 1-1.3 2.2-2.9 4.5-4.2s3.4-1.1 4.5-1c1 .2 1.9.3 3.8-.8 1.9-1 2.7-2.2 3.8-3.5a14.4 14.4 0 0 1 4.5-4.3m31 16.1v1.5a12 12 0 0 0-3.8 3.6 14.4 14.4 0 0 1-4.5 4.2c-2.3 1.3-3.5 1.2-4.5 1-1-.1-2-.3-3.8.8a11.8 11.8 0 0 0-3.8 3.6 14.5 14.5 0 0 1-4.5 4.2c-2.2 1.3-3.4 1.1-4.5 1-1-.2-2-.3-3.8.8-1.9 1-2.8 2.2-3.8 3.6a14.4 14.4 0 0 1-4.5 4.2c-2.2 1.3-3.4 1.1-4.5 1s-1.9-.4-3.8.7c-1.8 1.1-2.7 2.3-3.8 3.6-1 1.4-2.2 3-4.5 4.2-2.2 1.3-3.4 1.2-4.5 1-1-.1-1.9-.3-3.8.8v-1.5c2.3-1.3 3.5-1.1 4.5-1 1 .2 2 .3 3.8-.8a11.8 11.8 0 0 0 3.8-3.6c1-1.3 2.3-2.9 4.5-4.2 2.3-1.3 3.5-1.1 4.5-1 1 .2 2 .4 3.8-.7 1.9-1.1 2.8-2.3 3.8-3.6 1-1.4 2.2-3 4.5-4.2 2.3-1.3 3.5-1.2 4.5-1 1 .1 2 .3 3.8-.8 1.9-1 2.8-2.2 3.8-3.6s2.2-2.9 4.5-4.2c2.3-1.3 3.5-1.1 4.5-1 1 .2 2 .3 3.8-.8 1.9-1 2.8-2.2 3.8-3.6a14.4 14.4 0 0 1 4.5-4.2M801.6 98.7v1.5a12 12 0 0 0-3.8 3.6 14.4 14.4 0 0 1-4.5 4.2c-2.3 1.3-3.5 1.1-4.5 1-1-.2-2-.3-3.8.7a11.8 11.8 0 0 0-3.8 3.6 14.5 14.5 0 0 1-4.5 4.3c-2.3 1.3-3.5 1-4.5 1-1-.2-2-.4-3.8.7-1.9 1-2.8 2.3-3.8 3.6a14.4 14.4 0 0 1-4.5 4.2c-2.3 1.3-3.4 1.1-4.5 1-1-.2-2-.3-3.8.8a12 12 0 0 0-3.8 3.5c-1 1.4-2.2 3-4.5 4.3-2.2 1.3-3.4 1.1-4.5 1-1-.2-1.9-.3-3.8.7V137c2.3-1.3 3.5-1.1 4.5-1 1 .2 2 .4 3.8-.7a11.8 11.8 0 0 0 3.8-3.6c1-1.4 2.2-3 4.5-4.2 2.3-1.4 3.5-1.2 4.5-1 1 .1 2 .3 3.8-.8 1.9-1 2.8-2.2 3.8-3.6s2.2-2.9 4.5-4.2c2.3-1.3 3.4-1.1 4.5-1 1 .2 2 .3 3.8-.8a12 12 0 0 0 3.8-3.6c1-1.3 2.2-2.9 4.5-4.2 2.2-1.3 3.4-1.1 4.5-1 1 .2 1.9.3 3.8-.7 1.9-1.1 2.7-2.3 3.8-3.6a14.4 14.4 0 0 1 4.5-4.3",
    fill: "#9cb3e9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#home-devops-landscape_svg__bn)",
    transform: "rotate(-6 1144 -6234.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2 16.4c-1.9.6-3.1 2.9-2.8 0 .3-3.2-.3-6.6-1.5-9.5-.8-2-3.4-6.8-6-6.7a34 34 0 0 0-2.6 17.5c1.3 5.8 1.3 11.7-5.3 15.2S1.4 61.9.1 62.9a74.3 74.3 0 0 0 39 9.2l6-.2a68.8 68.8 0 0 0 33.1-9.2c1.7-5 2.4-10.1 2.7-15.3.1-3.2.2-15.4 1.4-18 1-2.1 2.1-2.7 4.3-3.3a21 21 0 0 0 7.7-3.2c1.3-1 3-2.8 3.6-4.2.2-.4 1.8-3.6 1.6-3.7-5.2-1-10.4-.3-15.3 1.3z",
    fill: "url(#home-devops-landscape_svg__bo)",
    transform: "translate(7.4 .4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5.7 3.3 3.4A7.2 7.2 0 0 0 0 10.2c.3 3.1 1.5 5.9 3.3 8.2a41 41 0 0 0 41.5-2.8S50 28.7 67 22.2a63 63 0 0 0 4.2-2.8A40.8 40.8 0 0 0 85.6.6a69 69 0 0 1-33.1 9.2l-6 .1A74.2 74.2 0 0 1 7.4.7z",
    fill: "url(#home-devops-landscape_svg__bp)",
    transform: "translate(0 62.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6.3A41.7 41.7 0 0 1 0 3c2.4 3.2 5.7 5.8 9.2 7.8a40.4 40.4 0 0 0 8.8 4 58 58 0 0 0 45.7-8C46.7 13.4 41.6.3 41.6.3",
    fill: "url(#home-devops-landscape_svg__bq)",
    transform: "translate(3.3 78)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#home-devops-landscape_svg__br)",
    opacity: 0.8,
    transform: "translate(684 108.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47 6.9 3.8-2.3v4.8L47 11.7z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.8 4.5 3.9-2.3 4.1 2.4L47 6.9z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 6.9-.1 4.8-4.1-2.4V4.5z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.6 9.4 4-2.3V12l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.5 7 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6 9.4v4.8l-4.1-2.4V7z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.4 11.9 4-2.3-.1 4.8-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.3 9.5 3.9-2.3 4.1 2.4-4 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4 11.9v4.8l-4.2-2.4V9.5z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 14.4 4-2.3V17l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.9 12 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 14.4v4.8l-4.1-2.4V12z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.8 16.9 4-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.7 14.5 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8 16.9v4.8l-4.2-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5 19.4 4-2.3V22l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.4 17 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 19.4v4.8l-4.2-2.4V17z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.3 21.9 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.1 19.5 4-2.3 4.1 2.4-4 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3 21.9v4.8L17 24.3v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.9 24.4 4-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8 22 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 24.4v4.8l-4.2-2.4V22z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.7 26.9 3.9-2.3v4.7l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 24.4 4-2.2 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 26.9v4.7l-4.2-2.4v-4.7z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.4 29.4 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.2 27 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 29.4v4.8l-4.2-2.4V27z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 29.6v4.7L5.4 36l-.8-.4-.4-.2v-3.5h.2z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 29.4 4.2 2.4L8 29.5l-4.2-2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 32.8 4.1 2.5v-3.5L3 31.1l-3-1.7z",
    fill: "#ffb0d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4 9.5v4.8l-4.2-2.4V7z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1 12 51 9.7v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 9.6 3.9-2.3L51 9.7 47 12z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1 12v4.8l-4.2-2.4V9.6z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.9 14.5 3.9-2.3V17l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.7 12 4-2.2 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9 14.5v4.8l-4.2-2.4V12z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.5 17 4-2.3-.1 4.8-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.4 14.6 3.9-2.2 4.1 2.4-3.9 2.2z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 17v4.8l-4.2-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.3 19.5 3.9-2.3V22l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.1 17.1 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3 19.5v4.8L30 21.9V17z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 22 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8 19.6 4-2.3 4 2.4L30 22z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 22v4.8l-4.2-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8 24.5 3.9-2.3V27l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.6 22 4-2.2 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8 24.5v4.8l-4.2-2.4V22z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.4 27 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.2 24.6 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4 27v4.8l-4.2-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.1 29.5 4-2.3V32l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 27 4-2.2 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 29.5v4.8L13 31.9V27z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8 32 4-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7 29.6 4-2.3 4 2.4L13 32z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 32v4.8l-4.1-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 32.2V37l-2.7 1.5-.8-.4-.4-.3v-3.3l.1-.1z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 32 3.9-2.2 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6 34.5v3.3L5.3 36l-.8-.4V32L8 34z",
    fill: "#ffb0d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.6 14.7 4-2.3-.1 4.8-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.5 12.3 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6 14.7v4.8L47.4 17v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.4 17.1 3.9-2.2v4.7l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.2 14.7 4-2.2 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4 17.1V22l-4.2-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 19.7 4-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.9 17.3 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 19.7v4.8L38.8 22v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.8 22.2 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.6 19.8 4-2.3 4.1 2.4-4 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8 22.2V27l-4.2-2.5v-4.7z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.5 24.7 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.3 22.3 4-2.3 4.1 2.4-4 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 24.7v4.8L30.3 27v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.3 27.1 3.9-2.2v4.8l-4 2.2z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1 24.8 4-2.4 4 2.5-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3 27.1V32L26 29.5v-4.7z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.9 29.7 3.9-2.3v4.8l-4 2.2z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7 27.3 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 29.7v4.7L21.7 32v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.6 32.1 4-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 29.7 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 32.1V37l-4.1-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.4 34.6 3.9-2.2V37l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.2 32.2 4-2.3 4 2.5-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 34.6v4.8L13.1 37v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 34.8v4.8l-2.6 1.5-1-.5-.3-.2v-3.3h.1z",
    fill: "#896bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 34.7 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 37.1v3.3l-3.3-1.9-.8-.4v-3.4l3.5 2z",
    fill: "#9c83ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 17.3v4.8l-4-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.8 19.8 4-2.3v4.8l-4 2.2z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.7 17.4 4-2.3 4 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8 19.8v4.7l-4.1-2.4v-4.7z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.5 22.3 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.3 19.9 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 22.3v4.8l-4.2-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.3 24.8 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.1 22.4 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3 24.8v4.8L39 27.2v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 27.3 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.8 24.9 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 27.3v4.8l-4.2-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.7 29.8 4-2.3v4.8l-4 2.2z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.6 27.4 3.9-2.3 4.2 2.4-4 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7 29.8v4.7l-4.1-2.4v-4.7z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.4 32.3 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 29.9 4-2.3 4 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 32.3V37l-4.2-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1 34.7 4-2.3v4.8l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 32.3 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1 34.7v4.8L22 37.1v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.8 37.3 4-2.3v4.7l-4 2.3z",
    fill: "#ff82c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.7 34.9 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8 37.3V42l-4.1-2.4v-4.8z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 37.4v4.8L19 43.7l-1-.5-.3-.2v-3.3h.1z",
    fill: "#ff69c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 37.3 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc5db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 39.7V43l-3.2-1.8-1-.6v-3.3l3.6 2.1z",
    fill: "#ffb0d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.6 4.8 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 2.4 42.4 0l4.1 2.4-4 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6 4.8v4.8l-4.2-2.4V2.4z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4 7.2 42.3 5v4.8l-4 2.3z",
    fill: "#facfff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.2 4.8 4-2.3 4 2.4-3.8 2.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4 7.2V12l-4.2-2.4V4.8z",
    fill: "#deb3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 9.8 4-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9 7.4 33.8 5l4.1 2.4L34 9.8z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 9.8v4.8l-4.2-2.4V7.4z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.8 12.2 3.9-2.2v4.7l-4 2.3z",
    fill: "#787eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6 9.8 4-2.3 4.1 2.4-4 2.3z",
    fill: "#a9b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8 12.2V17l-4.2-2.4V9.8z",
    fill: "#6566ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5 14.8 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.4 12.4 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 14.8v4.7l-4.2-2.3v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.3 17.2 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.1 14.8 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3 17.2V22L17 19.6v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.9 19.7 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8 17.3 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 19.7v4.8l-4.2-2.4v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.7 22.2 3.9-2.3v4.8L12.7 27z",
    fill: "#787eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 19.8 4-2.3 4 2.4-3.8 2.3z",
    fill: "#a9b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 22.2V27l-4.2-2.4v-4.8z",
    fill: "#6566ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.4 24.7 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.2 22.3 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 24.7v4.8l-4.2-2.4v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2 27.2 8 24.9v4.8L4 32z",
    fill: "#6566ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 24.8 4.1 2.4 4-2.3-4.2-2.4z",
    fill: "#a9b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 29.6 4.1 32v-4.8l-4-2.4z",
    fill: "#787eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 7.4 51 5v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 5 3.8-2.3L51 5l-4 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 7.4v4.8l-4-2.4V5z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.8 9.8 4-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.7 7.4 4-2.3 4 2.5-3.9 2.2z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8 9.8v4.8l-4.1-2.4V7.4z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.5 12.4 3.9-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.3 10 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 12.4v4.8l-4.2-2.4V10z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.3 14.8 3.9-2.2v4.8l-4 2.2z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.1 12.4 4-2.2 4 2.4-3.8 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3 14.8v4.8L30 17.2v-4.7z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 17.4 3.9-2.3v4.8l-4 2.3z",
    fill: "#facfff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8 15 4-2.3 4 2.4-3.8 2.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 17.4v4.8l-4.2-2.4V15z",
    fill: "#deb3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.7 19.8 4-2.2v4.7l-4 2.3z",
    fill: "#787eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.6 17.4 4-2.2 4 2.4-3.9 2.2z",
    fill: "#a9b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7 19.8v4.8l-4.1-2.4v-4.8z",
    fill: "#6566ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.4 22.4 3.9-2.3v4.8l-4 2.2z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.2 20 4-2.4 4 2.5-3.8 2.2z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4 22.4V27l-4.2-2.4V20z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.1 24.8 4-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 22.4 4-2.3 4 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 24.8v4.8L13 27.2v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8 27.3 4-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7 25 4-2.4 4 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 27.3v4.8l-4.1-2.4V25z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.6 29.8 4-2.3v4.8l-4 2.3z",
    fill: "#facfff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 27.4 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6 29.8v4.8l-4.1-2.4v-4.8z",
    fill: "#fffaff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6 10v4.8l-4.2-2.4V7.6z",
    fill: "#deb3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.3 12.5 4-2.3V15l-4 2.3z",
    fill: "#787eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.2 10.1 4-2.3 4 2.4-3.9 2.3z",
    fill: "#a9b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3 12.5v4.8l-4.1-2.4V10z",
    fill: "#6566ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 15 3.9-2.2v4.7l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.8 12.6 4-2.2 4 2.4L43 15z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 15v4.8l-4.2-2.4v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.8 17.5 3.9-2.3V20l-4 2.3z",
    fill: "#787eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.6 15.1 4-2.3 4 2.4-3.8 2.3z",
    fill: "#a9b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8 17.5v4.8l-4.2-2.4v-4.8z",
    fill: "#6566ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.5 20 3.9-2.2v4.7l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.3 17.6 4-2.3 4 2.4-3.8 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 20v4.8l-4.2-2.4v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.2 22.5 4-2.3V25l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1 20.1 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2 22.5v4.8l-4.1-2.4V20z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.9 25 3.9-2.3v4.8l-4 2.3z",
    fill: "#787eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7 22.6 4-2.3 4 2.4L26 25z",
    fill: "#a9b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 25v4.8l-4.2-2.4v-4.8z",
    fill: "#6566ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.6 27.5 4-2.3V30l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 25 4-2.2 4 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 27.5v4.8l-4.1-2.4V25z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.3 30 4-2.3v4.8l-4 2.3z",
    fill: "#facfff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.2 27.6 4-2.3 4 2.4-3.9 2.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 30v4.8l-4.1-2.4v-4.8z",
    fill: "#deb3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.1 32.5 4-2.3V35l-4 2.2z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 30 3.9-2.2 4.1 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 32.5v4.7L9 34.8v-4.7z",
    fill: "#ffabfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.8 15.1 4-2.3v4.8l-4 2.3z",
    fill: "#787eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.7 12.7 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#a9b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8 15.1v4.8l-4.2-2.4v-4.8z",
    fill: "#6566ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.4 17.7 4-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.3 15.3 4-2.3 4 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4 17.7v4.7L43.3 20v-4.7z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.2 20.1 4-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 17.7 4-2.3 4.2 2.4-4 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 20.1V25l-4.1-2.4v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 22.6 3.8-2.2V25L39 27.4z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.8 20.2 3.9-2.3 4.1 2.5-3.9 2.2z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 22.6v4.8L34.7 25v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.7 25.1 4-2.3v4.8L34.5 30z",
    fill: "#787eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.6 22.7 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#a9b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7 25.1V30l-4.2-2.4v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.3 27.6 4-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 25.2 30 23l4.1 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3 27.6v4.8L26.2 30v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1 30 4-2.2v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 27.7 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1 30v5l-4.2-2.4v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.8 32.6 4-2.3v4.8l-4 2.3z",
    fill: "#ff7df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.7 30.2 3.9-2.3 4.1 2.4-3.9 2.3z",
    fill: "#ffc0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8 32.6v4.8L17.7 35v-4.8z",
    fill: "#e064eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.6 35 3.9-2.2v4.8l-4 2.3z",
    fill: "#facfff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.4 32.7 4-2.3 4.1 2.4-3.9 2.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 35v5l-4.2-2.4v-4.8z",
    fill: "#fffaff"
  }))))));
};
export { SvgHomeDevopsLandscape as ReactComponent };
export default __webpack_public_path__ + "static/home-devops-landscape.77378437.svg";